import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { useHistory, useLocation } from 'react-router-dom';
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import axios from "axios";
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { LoadPanel } from 'devextreme-react/load-panel';
import notify from 'devextreme/ui/notify';
import { alert, confirm } from 'devextreme/ui/dialog';
import Toolbar, { Item } from "devextreme-react/toolbar";
import { DisableEnableControls, GetFormatedDateWithTime, isValidGuid, loadLookupFromStaticDataSource } from '../../../../common/Utils'
import { custom } from 'devextreme/ui/dialog';
import ValidationSummary from 'devextreme-react/validation-summary';
import PrimaryTab from "./tabs/PrimaryTab";
import AdditionalTab from "./tabs/AdditionalTab";
import routes from "../../../../assets/apiRoutes.json";
import TripsTab from "./tabs/TripsTab";
import DetailsTab from "./tabs/DetailsTab";
import { Enum, OMOperations, RecordTypes, SourceTypes, Statuses, TransactionStatus, TransactionTypes, YesNo, EMPTY_GUID, OrderStages, FmTransferFlag, FmTransferTiming, ChargeAndHoldType, isChargeAndHold, isChargeAndHoldShipment, SplitOrderMode } from "../../../../enum/Enum";
import { MESSAGES } from "../../../../common/Messages";
import EntityInfoBar, { OM_STAGE_TEXT } from "../../../../common/EntityInfoBar";
import MiscTab from "./tabs/MiscTab";
import { OptionsNoYes } from "../../../../const/constants";
import { ChargeHoldType, CommissionType, CreditReview, optionsYesNo, OrderSigned } from "../../../../const/Lookup";
import CommissionTab from "./tabs/CommissionTab";
import UserDefinedTab from "./tabs/UserDefinedTab";
import PaymentTab from "./tabs/PaymentTab";
import RetainersTab from "./tabs/RetainersTab";
import TotalsTab from "./tabs/TotalsTab";
import FreightTab from "./tabs/FreightTab";
import { DropDownButton, Popup } from "devextreme-react";
import ProductionStatusPopup from "./common/ProductionStatusPopup";
import CreateRequisitionPopup from "./common/CreateRequisitionPopup";
import CalculateCumulativeDiscountPopup from "./common/CalculateCumulativeDiscountPopup";
import CardConnectPayPopup from "./common/CardConnectPayPopup";
import PrintReportMenu from "../salesOrderManagement/common/PrintReportMenu";
import {
    prepareCardConnectPayOpen,
    verifyCardConnectVoidRefund,
    runCardConnectVoidRefund,
} from "./common/CardConnectPayCommon";
import { Alert } from "devextreme-react/cjs/chat";
import SplitOrderPopup from "./common/SplitOrderPopup";
import SplitDepositPopup from "./common/SplitDepositPopup";
import ItemsWithUnavailableQuantitiesPopup from "./common/ItemsWithUnavailableQuantitiesPopup";
import CustomerCredit from "../../../../id/common/customer/CustomerCredit";
import CustomerHistoryPopup from "./common/CustomerHistoryPopup";
import AutoSelectLotsPopup from "./common/AutoSelectLotsPopup";
import sanitizeHtml from "../../../../common/sanitizeHtml";

var skipDataLoading = false;
var profile = null;
var discountType ="N";

/* The OMD0015 answers that are not "the user pressed OK": values rather than a bare string sentinel,
   so a mistyped comparison cannot quietly come out as "go ahead and allocate". */
const AUTO_SELECT_LOTS_NOT_ASKED = Object.freeze({ cancelled: false, allocate: false, values: null });
const AUTO_SELECT_LOTS_CANCELLED = Object.freeze({ cancelled: true, allocate: false, values: null });

/**
 * Stages that make the FM transfer fields mandatory - Delphi's STAGE in ['N','A','S','C']
 * (uOMM0000.pas:4019), i.e. every stage that puts the order in front of FM.
 */
const FM_TRANSFER_REQUIRED_STAGES = [
    OrderStages.Pending,
    OrderStages.Assigned,
    OrderStages.PickedStaged,
    OrderStages.ShippedCompleted,
];

/** Maps the Stage* update-stage operation ids to their OrderStages code (single source of truth). */
const STAGE_OPERATION_CODES = {
    StageCanceled: OrderStages.Canceled,
    StageQuote: OrderStages.Quote,
    StagePlan: OrderStages.Plan,
    StageFuture: OrderStages.Future,
    StagePending: OrderStages.Pending,
    StageAssigned: OrderStages.Assigned,
    StagePickedStaged: OrderStages.PickedStaged,
    StageShippedCompleted: OrderStages.ShippedCompleted,
};

// Split Order operation ids (OMOperations keys) shared by the enable-map and the click handler.
const SPLIT_ORDER_OPERATIONS = Object.freeze({
    SplitOrder: "SplitOrder",
    ByTransaction: "SplitOrderByTransaction",
    ByTransactionAdvanced: "SplitOrderByTransactionAdvanced",
});

/** Back enabled when the URL has a non-empty `id` query parameter. */
function hasSalesOrderIdInUrlSearch(search) {
    const id = new URLSearchParams(search || '').get('id');
    return id != null && String(id).trim() !== '';
}

function Form(props) {
    var currentUser = props.oidc.user;   
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;

    const initialFormFields = {
        ROWID: EMPTY_GUID,
        KEYSEQUENCE: 1,
        CREATIONDATETIME: null,
        CREATIONUSERID: null,
        LASTUPDATEDATETIME: null,
        LASTUPDATEUSERID: null,
        COMPANYID: null,
        MODULE: 'OM',
        RECORDTYPE: 'R',
        R_PROFILE: null,
        R_CUSTOMER: null,
        TRANSACTIONTYPE: 'I',
        TRANSACTIONNUMBER: null,
        PROFILETRANSACTIONNUMBERMETHOD:null,
        TRANSACTIONDATE: new Date(),
        INVOICEDATE: null,
        TRANSACTIONDUEDATE: null,
        PURCHASEORDERNUMBER: null,
        R_TERMS: null,
        R_TAX: null,
        PRICELEVEL: 'A',
        STATUS: 'O',
        PICKSTATUS: null,
        DISCOUNTTYPE: YesNo.No,
        ORDERSIGNEDFLAG: YesNo.Yes,
        R_GLDEPARTMENT: null,
        REFERENCE: null,
        COMMENT: null,
        R_SHIPPER: null,
        R_SHIPVIA: null,
        R_CONSIGNEE: null,
        SHIPPINGDATE: new Date(),
        SHIPPERCOMMENT: null,
        R_EQUIPMENT: null,
        R_DRIVER: null,
        TRUCKREFERENCE: null,
        TRUCKARRIVALDATETIME: null,
        TRUCKDEPARTDATETIME: null,
        TRUCKCOMMENT: null,
        PRINTINVOICE: YesNo.Yes,
        PRINTBOL: YesNo.Yes,
        PRINTDELIVERYNOTIFICATION: YesNo.Yes,
        PRINTORDERACKNOWLEDGEMENT: YesNo.Yes,
        SENDFAX: YesNo.No,
        SENDEMAIL: YesNo.No,
        R_POHEADER: null,
        R_FMHEADER: null,
        R_AROPENITEMHEADER: null,
        R_ARCASHRECEIPTHEADER: null,
        CANCELDATE: null,
        CANCELCOMMENT: null,
        INVENTOTYAVAILABILITYSTATUS: null,
        STAGEWARNING:null,
        STAGEWARNINGCOMMENT:null,
        USERDEFINEDCODE_1: null,
        USERDEFINEDCODE_2: null,
        USERDEFINEDCODE_3: null,
        USERDEFINEDCODE_4: null,
        USERDEFINEDCODE_5: null,
        USERDEFINEDCODE_6: null,
        USERDEFINEDCODE_7: null,
        USERDEFINEDCODE_8: null,
        USERDEFINEDCODE_9: null,
        USERDEFINEDCODE_10: null,
        USERDEFINEDREFERENCE_1: null,
        USERDEFINEDREFERENCE_2: null,
        USERDEFINEDREFERENCE_3: null,
        USERDEFINEDREFERENCE_4: null,
        USERDEFINEDREFERENCE_5: null,
        USERDEFINEDREFERENCE_6: null,
        USERDEFINEDREFERENCE_7: null,
        USERDEFINEDREFERENCE_8: null,
        USERDEFINEDREFERENCE_9: null,
        USERDEFINEDREFERENCE_10: null,
        USERDEFINEDDATE_1: null,
        USERDEFINEDDATE_2: null,
        USERDEFINEDDATE_3: null,
        USERDEFINEDDATE_4: null,
        USERDEFINEDDATE_5: null,
        USERDEFINEDDATE_6: null,
        USERDEFINEDDATE_7: null,
        USERDEFINEDDATE_8: null,
        USERDEFINEDDATE_9: null,
        USERDEFINEDDATE_10: null,
        USERDEFINEDQUANTITY_1: null,
        USERDEFINEDQUANTITY_2: null,
        USERDEFINEDQUANTITY_3: null,
        USERDEFINEDQUANTITY_4: null,
        USERDEFINEDQUANTITY_5: null,
        USERDEFINEDQUANTITY_6: null,
        USERDEFINEDQUANTITY_7: null,
        USERDEFINEDQUANTITY_8: null,
        USERDEFINEDQUANTITY_9: null,
        USERDEFINEDQUANTITY_10: null,
        USERDEFINEDCOMMENT: null,
        DISCOUNTPERCENT: null,
        PARTIALSHIPMENT: YesNo.Yes,
        CREDITREVIEWDATE: null,
        CREDITREVIEWCOMMENT: null,
        SALESMETHOD: null,
        R_BILLTO: null,
        REASONCODE: null,
        FISCALPERIOD: null,
        FISCALYEAR: null,
        R_BATCH: null,
        COMMITDATE: null,
        SALESCOMMISIONADVANCE: null,
        PRINTPICKINGSLIP: YesNo.Yes,
        PRINTPACKINGSLIP: YesNo.Yes,
        R_ORIGINALTRANSACTION: null,
        FMTRIPNUMBER: null,
        FMPUSTOPNUMBER: null,
        COMMISSIONTYPE: YesNo.No,
        COMMISSIONTRANSACTIONPAYGROUP: null,
        COMMISSIONSETTLEMENTGROUP: null,
        R_SALESPERSON_1: null,
        R_SALESPERSON_2: null,
        R_SALESPERSON_3: null,
        R_SALESPERSON_4: null,
        R_SALESPERSON_5: null,
        FMTRANSFERFLAG: YesNo.No,
        CURRENCYBASIS: null,
        R_CURRENCY: null,
        CURRENCYCONVERSIONFACTOR: null,
        CURRENCYCONVERSIONDATE: null,
        STAGE: 'S',
        R_GLFUND: null,
        R_CAJOB: null,
        BACKORDERFLAG: YesNo.No,
        TRANSACTIONSUBTYPE: 'O',
        R_DISCOUNTTABLE: null,
        R_FMSHIPPER: null,
        R_FMDPPROFILE: null,
        R_TERMSDISCOUNT: null,
        R_NOTIFYPARTY: null,
        EDITRANSMITFLAG: YesNo.No,
        R_PATRON: null,
        R_CEACCOUNT: null,
        R_AGENT: null,
        R_CREDITREVIEWBY: null,
        TRANSACTIONORIGIN: null,
        R_PRIMARYDEFAULTWH: null,
        COMMITTYPE: YesNo.No,
        R_TRANSCURRENCYCODE: null,
        R_SECONDARYDEFAULTWH: null,
        R_PAYCURRENCYCODE: null,
        CURRENCYRATE: null,
        TRANSCURRENCYTYPE: 'H',
        PAYCURRENCYTYPE: 'H',
        RATETIMING: null,
        R_TRUCK: null,
        FMTRUCKREFERENCE: null,
        FMDRIVERREFERENCE: null,
        R_TRAILER: null,
        FMTRAILERREFERENCE: null,
        IMPORTFILENAME: null,
        DEFAULTDETAILDISCOUNT: null,
        CONSIGNMENT: YesNo.No,
        EQUIPMENT: null,
        DEFAULTFREIGHTRATE: null,
        MISCFEETYPE: 'A',
        CHARGEANDHOLDTYPE: 'A',
        USERDEFINEDCODE_11: null,
        USERDEFINEDCODE_12: null,
        USERDEFINEDCODE_13: null,
        USERDEFINEDCODE_14: null,
        USERDEFINEDCODE_15: null,
        USERDEFINEDCODE_16: null,
        USERDEFINEDCODE_17: null,
        USERDEFINEDCODE_18: null,
        USERDEFINEDCODE_19: null,
        USERDEFINEDCODE_20: null,
        USERDEFINEDDATE_11: null,
        USERDEFINEDDATE_12: null,
        USERDEFINEDDATE_13: null,
        USERDEFINEDDATE_14: null,
        USERDEFINEDDATE_15: null,
        USERDEFINEDDATE_16: null,
        USERDEFINEDDATE_17: null,
        USERDEFINEDDATE_18: null,
        USERDEFINEDDATE_19: null,
        USERDEFINEDDATE_20: null,
        USERDEFINEDQUANTITY_11: null,
        USERDEFINEDQUANTITY_12: null,
        USERDEFINEDQUANTITY_13: null,
        USERDEFINEDQUANTITY_14: null,
        USERDEFINEDQUANTITY_15: null,
        USERDEFINEDQUANTITY_16: null,
        USERDEFINEDQUANTITY_17: null,
        USERDEFINEDQUANTITY_18: null,
        USERDEFINEDQUANTITY_19: null,
        USERDEFINEDQUANTITY_20: null,
        USERDEFINEDREFERENCE_11: null,
        USERDEFINEDREFERENCE_12: null,
        USERDEFINEDREFERENCE_13: null,
        USERDEFINEDREFERENCE_14: null,
        USERDEFINEDREFERENCE_15: null,
        USERDEFINEDREFERENCE_16: null,
        USERDEFINEDREFERENCE_17: null,
        USERDEFINEDREFERENCE_18: null,
        USERDEFINEDREFERENCE_19: null,
        USERDEFINEDREFERENCE_20: null,
        TOTALFREIGHTRATE: null,
        R_ZONEFREIGHTRATEOVERRIDE: null,
        CONSIGNEEFREIGHTZONECODE:null,
        CREDITSTATUSREVIEW: YesNo.No,
        CREDITREVIEWREASON: null,
        INVENTORYREVIEW: YesNo.No,
        REVIEWER: null,
        REVIEWSTAGE: null,
        SETNO: null,
        R_SYNONYMSALTSHIPTO: null,
        HOLDATALTERNATEWH: YesNo.No,
        CREATEORDERATALTERNATEWH: YesNo.No,
        RECORD: null,
        CUSTOMERADDRESS: null,
        SHIPPERADDRESS: null,

        CUSTOMERIDENTITYID: null,
        PaymentProfile:null,
        CUSTOMERNAME: null,
        CUSTOMERADDRESS1: null,
        CUSTOMERADDRESS2: null,
        CUSTOMERCITY: null,
        CUSTOMERZIP: null,
        CUSTOMERSTATE: null,
        CUSTOMERTELEPHONE1: null,
        CUSTOMERCOUNTRY: null,
        CONSIGNEEIDENTITYID: null,
        CONSIGNEENAME: null,
        CONSIGNEEADDRESS1: null,
        CONSIGNEEADDRESS2: null,
        CONSIGNEECITY: null,
        CONSIGNEEZIP: null,
        CONSIGNEESTATE: null,
        CONSIGNEETELEPHONE1: null,
        CONSIGNEEFAX1: null,
        CUSTOMEREMAILADDRESS1: null,
        CONSIGNEEEMAILADDRESS1: null,

        CONSIGNEEADDRESS: null,
        CUSTOMERADDRESS: null,

        PROFILEDEFAULTSALESPERSON:null,

        CONSIGNEEADDRESS: '',
        CUSTOMERADDRESS: '',
        CANCELLED: 'O',
        QuantityOrderedSum: '',
        QuantityShippedSum: '',
        QuantityBackOrderSum: '',
        RecordCount: '',
        BackOrderTransactionNumber: '',
        FOREIGNTAXAMOUNT:null,
        FOREIGNFREIGHTAMOUNT:null,
        FOREIGNOTHERAMOUNT:null,
        FOREIGNTHIRDPARTYCHARGES:null,
        FOREIGNINVOICEAMOUNT:null,
        PROFILESHIPTOLOOKUP:null,
        PROFILEOMPREFIX:null,
        ProfileFMTransferTiming:null,
        ProfileFMTransferStage:null,
        TRIPWEIGHT:null,
        TRIPCUBES:null,
        GrossWeight: null,
        NetWeight:null,
        RPriceScheduleHeader:null,
        ProfileIncludeDiscountInUnitPrice:null,
        ProfileUseLineNumbers:null,
        ProfileDefaultWarehouse:null,
        ProfileDefaultWarehouseName:null,
        RLayoutId:null
    };
    const initialTotals={
        nonTaxed: 0.00,
        grossWeight: 0.00,
        netWeight: 0.00,
        taxed: 0.00,
        taxed_1: 0.00,
        totalTax: 0.00,
        itemTotal: 0.00,
        totalAmount: 0.00,
        discountableDetailAmount: 0.00,
        orderDiscountAmount: 0.00,
        taxRate: 0.00,
        calcOrdered: 0.00,
        calcShipped: 0.00,
        calcBackOrder: 0.00,
        totalLines: 0.00,
        arTermsDiscountPercent: 0.00,
        arTermsDiscountBasis: 0.00,
        arTermsDiscountAmount: 0.00,
        totalFeesAdded: 0.00,
        totalFeesIncluded: 0.00,
        totalFreightAmount: 0.00,
        discountableDetailAmtTax: 0.00,
        discountableDetailAmtNonTax: 0.00,
        orderDiscountAmtTax: 0.00,
        orderDiscountAmtNonTax: 0.00,
        outARPayments: 0.00,
        outARBalanceDue: 0.00,
        currency: ""
    }
    const [selectedTotals, setSelectedTotals] = useState(initialTotals);
    const history = useHistory();
    const location = useLocation();
    const backButtonEnabled = useMemo(
        () => hasSalesOrderIdInUrlSearch(location.search),
        [location.search]
    );
    var accessToken = props.oidc.user.access_token;
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [selectedTabIndex, setSelectedTabIndex] = useState(0);
    const [formFields, setformFields] = useState(initialFormFields);
    const [showProductionStatusPopup, setShowProductionStatusPopup] = useState({ visible: false, headerRowId: null, title: "Production Status" });
    const [showCardConnectPayPopup, setShowCardConnectPayPopup] = useState({
        visible: false,
        headerRowId: null,
        transactionNumber: "",
        customer: "",
        amount: null,
        paymentProfile: "",
    });
    const [selectedRequisitionData, setSelectedRequisitionData] = useState({ visible: false, data: [] });
    const [showCumulativeDiscountPopup, setShowCumulativeDiscountPopup] = useState({ visible: false, headerRowId: null, rCustomer: null, rDiscountTable: null, shippingDate: null, companyId: null, discountCode: null });
    const [detailGridRefreshNonce, setDetailGridRefreshNonce] = useState(0);
    /* OMD0015 "Shipment", raised before a stage change (OMM0000.PopUpShippedQuantityDialog). Whole-order
       scope: no detail row, so every line still without a lot is allocated. `showLotSelection` is the
       server's bLotsParam - false means the dialog is only asking for the Ship Quantity Basis. */
    const [showAutoSelectLots, setShowAutoSelectLots] = useState({
        visible: false,
        showLotSelection: false,
        pickMethod: null,
        pickSequence: null,
    });
    /* Resolves once the user answers OMD0015, so the stage change can wait on the dialog the way
       Delphi's ShowModal did inside BeforePost. */
    const autoSelectLotsResolverRef = useRef(null);
    const [paymentRefreshNonce, setPaymentRefreshNonce] = useState(0);
    const formFieldsRef = useRef(formFields);
    const [showCustomerCreditForm, setShowCustomerCreditForm] = useState(false);
    const [showCustomerHistory, setShowCustomerHistory] = useState({ visible: false, headerRowId: null, customerId: null });
    const [customerCreditLoading, setCustomerCreditLoading] = useState(false);
    const customerCreditPopupRef = useRef(null);

    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);
    const position = { of: '#accordion-containe2' };
    const formRefs = useRef({});
    const buttonDropDownOptions = { width: 430, height: 400 };
    const [dropDownItems, setDropDownItems] = useState([]);
    const [showSplitOrderPopup, setShowSplitOrderPopup] = useState({ visible: false, headerRowId: null });
    const [showSplitDepositPopup, setShowSplitDepositPopup] = useState({ visible: false, headerRowId: null });
    // Items With Unavailable Quantities gate (legacy OMD0016) - opened when the server refuses the
    // stage change because detail lines exceed the available quantity.
    const [showUnavailableQuantities, setShowUnavailableQuantities] = useState({
        visible: false,
        headerRowId: null,
        stageFrom: null,
        stageTo: null,
        reversePayments: false,
        /* The OMD0015 answers, held across the popup: the stage change is retried from
           handleUnavailableQuantitiesContinue, so both the Ship Quantity Basis it is posted with and the
           lot allocation belong to that retry rather than to the attempt that was refused. */
        shipQuantityBasis: null,
        autoSelectLots: null,
        check: null,
    });
    const handleFormSubmit = async (e) => {
        e.preventDefault();
        setLoadPanelVisible(true);
        setIsFormSubmitted(true);
        try {
            if (formFields.ROWID === EMPTY_GUID) {
                await insertTransacation();
            }
            else {
                await updateTransaction();
            }

        } catch (error) {
            console.error('Error submitting form:', error);
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };

    const insertTransacation = async () => {
        try {
            const url = "om/transaction/PostTransaction";

            let fields = formFields;
            /* Fill the date fields with formatted date */
            fields.USERDEFINEDDATE_1 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_1);
            fields.USERDEFINEDDATE_2 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_2);
            fields.USERDEFINEDDATE_3 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_3);
            fields.USERDEFINEDDATE_4 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_4);
            fields.USERDEFINEDDATE_5 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_5);
            fields.USERDEFINEDDATE_6 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_6);
            fields.USERDEFINEDDATE_7 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_7);
            fields.USERDEFINEDDATE_8 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_8);
            fields.USERDEFINEDDATE_9 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_9);
            fields.USERDEFINEDDATE_10 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_10);
            fields.USERDEFINEDDATE_11 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_11);
            fields.USERDEFINEDDATE_12 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_12);
            fields.USERDEFINEDDATE_13 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_13);
            fields.USERDEFINEDDATE_14 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_14);
            fields.USERDEFINEDDATE_15 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_15);
            fields.USERDEFINEDDATE_16 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_16);
            fields.USERDEFINEDDATE_17 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_17);
            fields.USERDEFINEDDATE_18 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_18);
            fields.USERDEFINEDDATE_19 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_19);
            fields.USERDEFINEDDATE_20 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_20);
            fields.SHIPPINGDATE= GetFormatedDateWithTime(formFields.SHIPPINGDATE);
            fields.TRUCKARRIVALDATETIME= GetFormatedDateWithTime(formFields.TRUCKARRIVALDATETIME);
            fields.TRUCKDEPARTDATETIME= GetFormatedDateWithTime(formFields.TRUCKDEPARTDATETIME);
            fields.CANCELDATE= GetFormatedDateWithTime(formFields.CANCELDATE);
            fields.CREDITREVIEWDATE= GetFormatedDateWithTime(formFields.CREDITREVIEWDATE);
            fields.COMMITDATE= GetFormatedDateWithTime(formFields.COMMITDATE);
            fields.CURRENCYCONVERSIONDATE= GetFormatedDateWithTime(formFields.CURRENCYCONVERSIONDATE);
            fields.TRANSACTIONDATE= GetFormatedDateWithTime(formFields.TRANSACTIONDATE);
            fields.INVOICEDATE= GetFormatedDateWithTime(formFields.INVOICEDATE);
            fields.TRANSACTIONDUEDATE= GetFormatedDateWithTime(formFields.TRANSACTIONDUEDATE);
            const response = await axios.post(`${window._env_.REACT_APP_APIS}/${url}`, fields, {
                headers: {
                    'Content-Type': 'application/json',
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (!response.data.ERRORS.length > 0) {
                setformFields(prevFields => ({
                    ...prevFields,
                    ROWID: response.data.ROWID,
                    RECORD: response.data.RECORD
                }));
                notify(
                    {
                        message: "Transaction Created",
                        width: 100,
                    },
                    'success',
                    3000,
                );
                setIsFormSubmitted(false);
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            if (error.response.data.ERRORS && error.response.data.ERRORS.length > 0) {
                const errorHtml = error.response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                custom({
                    title: "Errors",
                    messageHtml: errorHtml,
                    buttons: [{ text: "OK", onClick: () => { } }]
                }).show();
            }
            else {
                notify(
                    {
                        message: "Could not create transaction. An error occurred",
                        width: 100,
                    },
                    'error',
                    3000,
                );
            }

            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };
    const updateTransaction = async () => {
        try {
            const url = "om/transaction/PutTransaction";

            let fields = formFields;
            fields.LASTUPDATEDATETIME = null;
            /* Fill the date fields with formatted date */
            fields.USERDEFINEDDATE_1 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_1);
            fields.USERDEFINEDDATE_2 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_2);
            fields.USERDEFINEDDATE_3 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_3);
            fields.USERDEFINEDDATE_4 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_4);
            fields.USERDEFINEDDATE_5 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_5);
            fields.USERDEFINEDDATE_6 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_6);
            fields.USERDEFINEDDATE_7 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_7);
            fields.USERDEFINEDDATE_8 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_8);
            fields.USERDEFINEDDATE_9 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_9);
            fields.USERDEFINEDDATE_10 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_10);
            fields.USERDEFINEDDATE_11 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_11);
            fields.USERDEFINEDDATE_12 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_12);
            fields.USERDEFINEDDATE_13 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_13);
            fields.USERDEFINEDDATE_14 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_14);
            fields.USERDEFINEDDATE_15 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_15);
            fields.USERDEFINEDDATE_16 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_16);
            fields.USERDEFINEDDATE_17 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_17);
            fields.USERDEFINEDDATE_18 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_18);
            fields.USERDEFINEDDATE_19 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_19);
            fields.USERDEFINEDDATE_20 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_20);
            fields.SHIPPINGDATE= GetFormatedDateWithTime(formFields.SHIPPINGDATE);
            fields.TRUCKARRIVALDATETIME= GetFormatedDateWithTime(formFields.TRUCKARRIVALDATETIME);
            fields.TRUCKDEPARTDATETIME= GetFormatedDateWithTime(formFields.TRUCKDEPARTDATETIME);
            fields.CANCELDATE= GetFormatedDateWithTime(formFields.CANCELDATE);
            fields.CREDITREVIEWDATE= GetFormatedDateWithTime(formFields.CREDITREVIEWDATE);
            fields.COMMITDATE= GetFormatedDateWithTime(formFields.COMMITDATE);
            fields.CURRENCYCONVERSIONDATE= GetFormatedDateWithTime(formFields.CURRENCYCONVERSIONDATE);
            fields.TRANSACTIONDATE= GetFormatedDateWithTime(formFields.TRANSACTIONDATE);
            fields.INVOICEDATE= GetFormatedDateWithTime(formFields.INVOICEDATE);
            fields.TRANSACTIONDUEDATE= GetFormatedDateWithTime(formFields.TRANSACTIONDUEDATE);

            if (fields.TRANSACTIONNUMBER === null && fields.RECORDTYPE !== 'P') {
                let transNumber=await GenerateTransactionNo();
                if(transNumber)
                  fields.TRANSACTIONNUMBER = (fields?.PROFILEOMPREFIX??"")+transNumber;
            }
            const response = await axios.put(`${window._env_.REACT_APP_APIS}/${url}`, fields, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (!response.data || !response.data.ERRORS.length > 0) {
                notify(
                    {
                        message: "Transaction Updated",
                        width: 100,
                    },
                    'success',
                    3000,
                );
                let data = response.data.Data;
                setformFields(prevFields => ({
                    ...prevFields,
                    CREDITSTATUSREVIEW: data.CREDITSTATUSREVIEW,
                    CREDITREVIEWREASON: data.CREDITREVIEWREASON,
                }));
                setIsFormSubmitted(false);
            }
        } catch (error) {
            console.error('Error submitting form:', error);

            if (error.response.data.ERRORS && error.response.data.ERRORS.length > 0) {
                var hasWarning = false;
                var hasConfirmation = false;
                var errorMessage = "";
                var errorsArray = [];

                for (let i = 0; i < error.response.data.ERRORS.length; i++) {

                    if (error.response.data.ERRORS[i].startsWith("[XYZWarning]")) {
                        hasWarning = true;
                        errorMessage = error.response.data.ERRORS[i];
                        errorMessage = errorMessage.replace('[XYZWarning]', '');
                        errorMessage = errorMessage.replace(/(?:\r\n|\r|\n)/g, '<br>');
                    }
                    else if (error.response.data.ERRORS[i].startsWith("[XYZConfirmation]")) {
                        hasConfirmation = true;
                        errorMessage = error.response.data.ERRORS[i];
                        errorMessage = errorMessage.replace('[XYZConfirmation]', '');
                        errorMessage = errorMessage.replace(/(?:\r\n|\r|\n)/g, '<br>');
                    }
                    else {
                        errorsArray.push(error.response.data.ERRORS[i]);
                    }
                }

                if (errorsArray.length > 0) {
                    const errorHtml = errorsArray.map(err => `<div>${err}</div>`).join('');
                    custom({
                        title: "Errors",
                        messageHtml: errorHtml,
                        buttons: [{ text: "OK", onClick: () => { } }]
                    }).show();
                }
                else {
                    if (hasWarning) {
                        alert(errorMessage, "Warning");


                    }
                    else if (hasConfirmation) {

                    }
                }
            }
            else {
                notify(
                    {
                        message: "Could not create transaction. An error occurred",
                        width: 100,
                    },
                    'error',
                    3000,
                );
            }

            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };

    const primaryFormLookupsLoad = (formRefs) => {
        primaryFormLoad(formRefs);
        additionalFormLoad();

    }

    const primaryFormLoad = (formRefs) => {
        var transactionTypes = [
            { "Rowid": "I", "Code": "Order/Invoice - Inventory Effect" },
            { "Rowid": "C", "Code": "Credit - Inventory Effect" },
            { "Rowid": "J", "Code": "$ Adjustment - No Inventory Effect - AR Credit" }];
        loadLookupClient(formRefs, "TRANSACTIONTYPE", transactionTypes);
        var stages = [
            { "Rowid": "L", "Code": "Canceled - No Inventory Effect" },
            { "Rowid": "Q", "Code": "Quote - No Inventory Effect" },
            { "Rowid": "P", "Code": "Plan - No Inventory Effect" },
            { "Rowid": "F", "Code": "Future - No Effect On Net Available" },
            { "Rowid": "N", "Code": "Pending - Effects Net Available" },
            { "Rowid": "A", "Code": "Assigned - Effect Available" },
            { "Rowid": "S", "Code": "Picked/Staged - Effect Available" },
            { "Rowid": "C", "Code": "Shipped/Completed - Effect Available" }
        ];
        loadLookupClient(formRefs,"STAGE", stages);
        handleMiscFormLoad();
    }
    function DiscountTypeChange(t) {
        const formMap = {
            I: ['DEFAULTDETAILDISCOUNT'],
            F: ['DISCOUNTPERCENT', 'DISCOUNTPERCENTTOTALTAB'],
            B: ['DEFAULTDETAILDISCOUNT', 'DISCOUNTPERCENT', 'DISCOUNTPERCENTTOTALTAB'],
            T: ['DISCOUNTPERCENT', 'DISCOUNTPERCENTTOTALTAB'],
            D: ['R_DISCOUNTTABLE'],
            N: []  
        };
        const allFields = [
            'DISCOUNTPERCENT',
            'DISCOUNTPERCENTTOTALTAB',
            'R_DISCOUNTTABLE',
            'DEFAULTDETAILDISCOUNT'
        ];
        const enabledFields = formMap[t] || ['DISCOUNTPERCENT', 'DISCOUNTPERCENTTOTALTAB'];
        allFields.forEach(field => {
            const ref = formRefs.current[field];
            if (ref && ref.instance()) {
                const shouldEnable = enabledFields.includes(field);
                const isCurrentlyDisabled = ref.instance().option('disabled');
    
                if (shouldEnable && isCurrentlyDisabled) {
                    ref.instance().option('disabled', false);
                } else if (!shouldEnable && !isCurrentlyDisabled) {
                     setformFields(prevFields => ({
                        ...prevFields,
                        [field]: ''
                    }));
                    ref.instance().option('value', null);
                    ref.instance().option('disabled', true);
                }
            }
        });
    }
    const tripFormLoad =(formRefs)=>{
        loadLookupFromStaticData(formRefs,"FMTRANSFERFLAG",[{ "id": "N", "name": "None" }, { "id": "Y", "name": "Yes, Create FM Dispatch Object" }, { "id": "A", "name": "Yes, Create Both FM Billing Record and FM Dispatch Object" }]);
    }
    const handleMiscFormLoad =()=>{
        loadLookupFromStaticDataSource("CREDITSTATUSREVIEW",CreditReview,formFields,formRefs);
        loadLookupFromStaticDataSource("HOLDATALTERNATEWH",OptionsNoYes,formFields,formRefs);
        loadLookupFromStaticDataSource("ORDERSIGNEDFLAG",OrderSigned,formFields,formRefs);
        loadLookupFromStaticDataSource("PARTIALSHIPMENT",optionsYesNo,formFields,formRefs);
        loadLookupFromStaticDataSource("CREATEORDERATALTERNATEWH",OptionsNoYes,formFields,formRefs);
        loadLookupFromStaticDataSource("CONSIGNMENT",optionsYesNo,formFields,formRefs);
        loadLookupFromStaticDataSource("CHARGEANDHOLDTYPE",ChargeHoldType,formFields,formRefs);
        loadLookupFromStaticDataSource("INVENTORYREVIEW",optionsYesNo,formFields,formRefs);
        if (formFieldsRef.current.HOLDATALTERNATEWH == YesNo.Yes)
            DisableEnableControls('CREATEORDERATALTERNATEWH', false, formRefs)
        else
            DisableEnableControls('CREATEORDERATALTERNATEWH', true, formRefs)
        if(selectedTotals){
        setformFields(prevFields => ({
            ...prevFields,
            GrossWeight: selectedTotals.grossWeight,
            NetWeight: selectedTotals.netWeight
        }));
    }
    }
    const handleCommissionFormLoad = () => {
        loadLookupFromStaticDataSource("COMMISSIONTYPE", CommissionType, formFields, formRefs);
        if (formFieldsRef.current.COMMISSIONTYPE == 'H')
            DisableEnableControls('R_CEACCOUNT', false, formRefs)
        else
            DisableEnableControls('R_CEACCOUNT', true, formRefs)
    }
    const handleTotalsFormLoad =()=>{
        loadLookupFromStaticData(formRefs,"SENDFAX", [{ "id": "Y", "name": "Yes" }, { "id": "N", "name": "No" }]);
        loadLookupFromStaticData(formRefs,"SENDEMAIL", [{ "id": "Y", "name": "Yes" }, { "id": "N", "name": "No" }]);
        loadLookupFromStaticData(formRefs,"PRINTORDERACKNOWLEDGEMENT",  [{ "id": "Y", "name": "Yes" }, { "id": "N", "name": "No" }, { "id": "P", "name": "Printed" }]);
        loadLookupFromStaticData(formRefs,"PRINTPICKINGSLIP",  [{ "id": "N", "name": "Not Ready To Pick/Not Required" }, { "id": "Y", "name": "Yes, Ready To Be Picked/Print" }, { "id": "P", "name": "Printed/Already Picked" }]);
        loadLookupFromStaticData(formRefs,"PRINTDELIVERYNOTIFICATION",  [{ "id": "Y", "name": "Yes" }, { "id": "N", "name": "No" }, { "id": "P", "name": "Printed" }]);
        loadLookupFromStaticData(formRefs,"PRINTPACKINGSLIP",  [{ "id": "Y", "name": "Yes" }, { "id": "N", "name": "No" }, { "id": "P", "name": "Printed" }]);
        loadLookupFromStaticData(formRefs,"PRINTBOL", [{ "id": "Y", "name": "Yes" }, { "id": "N", "name": "No" }]);
        loadLookupFromStaticData(formRefs,"PRINTINVOICE",  [{ "id": "Y", "name": "Yes" }, { "id": "N", "name": "No" }, { "id": "P", "name": "Printed" }]);
        loadLookupFromStaticData(formRefs,"EDITRANSMITFLAG",  [{ "id": "N", "name": "No" }, { "id": "Y", "name": "Yes" }]);
        
        if (discountType == "N" || discountType == "I" || discountType == "D")
        {
            if (formRefs.current['DISCOUNTPERCENTTOTALTAB'].instance())
            {
                formRefs.current['DISCOUNTPERCENTTOTALTAB'].instance().option('disabled', true);
            }
        }
    }
    
    const additionalFormLoad =()=>{
        loadLookupFromStaticData(formRefs,"STATUS",[{ "id": "O", "name": "Open" }, { "id": "H", "name": "Hold" }, { "id": "L", "name": "Ready To Commit Later" }]);
        loadLookupFromStaticData(formRefs,"COMMITTYPE",[{ "id": "N", "name": "Not Commited" },{ "id": "P", "name": "AC Pre-Commit" },{ "id": "N", "name": "Final Commit" },]);
        loadLookupFromStaticData(formRefs,"BACKORDERFLAG",[{ "id": "N", "name": "No" },{ "id": "Y", "name": "Yes" }]);
        loadLookupFromStaticData(formRefs,"CANCELLED",[{ "id": "O", "name": "Open" },{ "id": "L", "name": "Cancelled" }]);
        const priceLevels = [{ id: 'A', name: "Price Level - A" }, { id: 'B', name: "Price Level - B" }, { id: 'C', name: "Price Level - C" }, { id: 'D', name: "Price Level - D" }, { id: 'E', name: "Price Level - E" },
        { id: 'F', name: "Price Level - F" }, { id: 'G', name: "Price Level - G" }, { id: 'H', name: "Price Level - H" }, { id: 'I', name: "Price Level - I" }, { id: 'J', name: "Price Level - J" }, { id: 'K', name: "Price Level - K" }, { id: 'L', name: "Price Level - L" }, { id: 'M', name: "Price Level - M" },
        { id: 'N', name: "Price Level - N" }, { id: 'O', name: "Price Level - O" }, { id: 'P', name: "Price Level - P" }, { id: 'Q', name: "Price Level - Q" }, { id: 'R', name: "Price Level - R" },
        { id: 'S', name: "Price Level - S" }, { id: 'T', name: "Price Level - T" }, { id: 'U', name: "Price Level - U" }, { id: 'V', name: "Price Level - V" }, { id: 'X', name: "Price Level - X" },
        { id: 'Y', name: "Price Level - Y" }, { id: 'Z', name: "Price Level - Z" }
        ];
        loadLookupFromStaticData(formRefs, "PRICELEVEL", priceLevels);
        const discountTypes = [{ id: 'N', name: "None" }, { id: 'I', name: "Item Discount" }, { id: 'T', name: "Total Discount %" }, { id: 'F', name: "Total Discount Flat" }, { id: 'B', name: "Both Item & Total Discount" },
        { id: 'D', name: "Discount Table" } 
        ];
        loadLookupFromStaticData(formRefs, "DISCOUNTTYPE", discountTypes);
        
        if(discountType == "N")
        {
            if (formRefs.current['DISCOUNTPERCENT']){
                formRefs.current['DISCOUNTPERCENT'].instance().option('disabled', true);
            }
            if (formRefs.current['R_DISCOUNTTABLE']){
                formRefs.current['R_DISCOUNTTABLE'].instance().option('disabled', true);
            }
            if (formRefs.current['DEFAULTDETAILDISCOUNT']){
                formRefs.current['DEFAULTDETAILDISCOUNT'].instance().option('disabled', true);
            }
        }
        else
        {
            DiscountTypeChange(discountType);
        }
    }
    const loadLookupClient = (formRefs,name, data) => {

        try {
            if (formRefs.current[name]) {

                formRefs.current[name].instance().option('dataSource', data);
                formRefs.current[name].instance().option('valueExpr', 'Rowid');
                formRefs.current[name].instance().option('displayExpr', 'Code');
            } 

        } catch (error) {
            console.error('Error fetching item detail:', error);
        } finally {
            /// setTimeout(hideLoadPanel, 1000);
        }
    };
    const loadLookupFromStaticData = (formRefs, name, dataSource) => {
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', 'id');
            formRefs.current[name].instance().option('displayExpr', 'name');
            if (formFields[name])
                formRefs.current[name].instance().option('value', formFields[name]);
        }

    };

    const handleReset = () => {

        var rowid = props.id;
        if (rowid != null && rowid != undefined && rowid != '') {
            GetHeaderInfoById(rowid);
        }
        else {
            skipDataLoading = true;
            setformFields(initialFormFields);
            skipDataLoading = false;
            EnableControlsForNewRecord();
        }

    };

    const DeleteClick = async () => {
        let result = await confirm("<i>Are you sure you want to delete this record?</i>", "Delete");
        if (result) {
            if (formFields.STATUS === 'Z') {
                alert("This record is already committed and cannot be deleted.", "Delete");
                return;
            }

            if (formFields.COMMITTYPE === 'P') {
                let confirmPrecommit = await confirm("This Transaction has been pre-committed.\nAre you sure you wish to delete?", "Delete");
                if (!confirmPrecommit) {
                    return;
                }
            }

            if (['A', 'S'].includes(formFields.STAGE) && formFields.STAGEWARNING === YesNo.Yes) {
                if (formFields.STAGEWARNINGCOMMENT?.trim()) {
                    let confirmStage = await confirm(formFields.STAGEWARNINGCOMMENT + "\nDo You Wish To Continue?", "Delete");
                    if (!confirmStage) {
                        return;
                    }
                }
            }
                setLoadPanelVisible(true);
                try {
                    const response = await axios.post(`${window._env_.REACT_APP_APIS}/${'om/transaction/DeleteTransaction'}`, formFields.ROWID, {
                        headers: {
                            'Content-Type': 'application/json',
                            access_token: accessToken,
                            Authorization: `Bearer ${accessToken}`
                        },
                    });
                    if (!response.data.ERRORS.length > 0) {
                        notify(
                            {
                                message: "Transaction Deleted",
                                width: 100,
                            },
                            'success',
                            3000,
                        );
                        setLoadPanelVisible(false);
                        history.push('/om/transactions/salesorders/salesorder-data-entry');
                    }
                    else {
                        setLoadPanelVisible(false);
                        const errorHtml = response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                        custom({
                            title: "Errors",
                            messageHtml: errorHtml,
                            buttons: [{ text: "OK", onClick: () => { } }]
                        }).show();
                    }
                }
                catch (error) {

                    setLoadPanelVisible(false);

                    if (error.response.data.ERRORS && error.response.data.ERRORS.length > 0) {
                        const errorHtml = error.response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                        custom({
                            title: "Errors",
                            messageHtml: errorHtml,
                            buttons: [{ text: "OK", onClick: () => { } }]
                        }).show();
                    }
                    else {
                        notify(
                            {
                                message: "Could not delete transaction. An error occurred",
                                width: 100,
                            },
                            'error',
                            3000,
                        );
                    }
                }
            }
            }

    const addNewRecordClick = () => {
        setIsFormSubmitted(false);
        skipDataLoading = true;
        setformFields(initialFormFields);
        setSelectedTotals(initialTotals);
        skipDataLoading = false;
        history.push('/om/transactions/salesorders/add-salesorder');
        EnableControlsForNewRecord();
    }
    const mergeAddresses = (responseData) => {
         mergeCustomerAddresses(responseData);
         mergeConsigneeAddresses(responseData);
        return responseData;
    }
        const mergeCustomerAddresses = (responseData) => {
                responseData.CUSTOMERADDRESS = (responseData.CUSTOMERNAME ?? "").trim()
                                                + "\n" + (responseData.CUSTOMERADDRESS1 ?? "").trim() 
                                                + "\n" + (responseData.CUSTOMERADDRESS2 ?? "").trim() 
                                                + "\n" + (responseData.CUSTOMERCITY ?? "").trim() +" "+ (responseData.CUSTOMERSTATE ?? "").trim() +" "+ (responseData.CUSTOMERZIP ?? "").trim()+" " + (responseData.CUSTOMERCOUNTRY ?? "").trim()
                                                + "\n" + "Phone: " + (responseData.CUSTOMERTELEPHONE1 ?? "").trim() 
                                                + "\n" + "Fax: " + (responseData.CUSTOMERFAX1 ?? "").trim() 
                                                + "\n" + "Email: " +(responseData.CUSTOMEREMAILADDRESS1??"").trim()
             return responseData;
           }
            const mergeConsigneeAddresses = (responseData) => {
            responseData.CONSIGNEEADDRESS = (responseData.CONSIGNEENAME ?? "").trim()  
                                            + "\n" + (responseData.CONSIGNEEADDRESS1 ?? "").trim() 
                                            + "\n" + (responseData.CONSIGNEEADDRESS2 ?? "").trim() 
                                            + "\n" + (responseData.CONSIGNEECITY ?? "").trim()+" " + (responseData.CONSIGNEESTATE ?? "").trim()+" " + (responseData.CONSIGNEEZIP ?? "").trim() + " " + (responseData.CONSIGNEECOUNTRY ?? "").trim()
                                            + "\n" + "Phone: " + (responseData.CONSIGNEETELEPHONE1 ?? "").trim()
                                            + "\n" + "Fax: " + (responseData.CONSIGNEEFAX1 ?? "").trim() 
                                            + "\n" + "E-mail 1 : " +(responseData.CONSIGNEEEMAILADDRESS1??"").trim()

             return responseData;
          }
    const GetHeaderInfoById = (id, profileId=null) => {
        try {
            setLoadPanelVisible(true);
            let url = '';
            if(profileId)
                url = `${window._env_.REACT_APP_APIS}/om/transaction/GetTransaction?profileRowid=${profileId}`;
            else
                url = `${window._env_.REACT_APP_APIS}/om/transaction/GetTransaction?rowid=${id}`;

            axios.get(`${url}`, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            }).then((res) => {
                const responseData = res.data;
                // profile = res.data.Item2;

                if (responseData?.ROWID) {
                    skipDataLoading = true;
                    responseData.INVENTORYUNITNOTUSED = 1;
                    mergeAddresses(responseData);
                    setformFields(responseData);
                    skipDataLoading = false;

                    if (formRefs.current["R_PROFILE"]) {
                     formRefs.current["R_PROFILE"].instance().option('disabled', true);
                    }
                    discountType = responseData.DISCOUNTTYPE
                }
                else {
                    console.error('Failed to get transaction data');
                }
               setTimeout(() =>setLoadPanelVisible(false), 1000);       
            });


        } catch (error) {
            console.error('Error failed to get transaction data:', error);
        } finally {
         }
    };

    useEffect(() => {
        var rowid = props.id;
        var profileRowid = props.RProfile;
        if (rowid != null && rowid != undefined && rowid != '') {
            GetHeaderInfoById(rowid, profileRowid);
            GetTotals(rowid, formFields.SHIPPINGDATE);
        }
    }, [props.id,props.RProfile]);

    // Loads a different transaction into this page (e.g. the order created by Split Order).
    // Pushing the new `id` onto the URL is what drives the reload: the route component is not
    // remounted by a query-string change, but `props.id` changes and the effect above re-fetches
    // the header/totals, which in turn refreshes the child tabs. RProfile is intentionally dropped
    // so GetHeaderInfoById loads by rowid instead of creating a new record from the profile.
    const openTransactionById = useCallback((rowId) => {
        if (!rowId || rowId === EMPTY_GUID || rowId === props.id) return;
        setIsFormSubmitted(false);
        setSelectedTotals(initialTotals);
        setDetailGridRefreshNonce((n) => n + 1);
        setPaymentRefreshNonce((n) => n + 1);
        history.push('/om/transactions/salesorders/edit-salesorder?id=' + rowId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [history, props.id]);

useEffect(() => {
  formFieldsRef.current = formFields;
}, [formFields]);

    // Operations dropdown: hide/show in .filter(), disable in .map(). Uses formFieldsRef for current values.
    const setActionDropDownItems = useCallback(() => {
        const fields = formFieldsRef.current;
        const hasRecord = fields.ROWID && fields.ROWID !== "00000000-0000-0000-0000-000000000000";
        if (!hasRecord) {
            setDropDownItems([]);
            return;
        }
        const items = Object.entries(OMOperations)
            .filter(([id]) => {
                // Hide items by condition: return false to hide, true to show
                if (id === "CardConnectPay" || id === "CardConnectVoidRefund") {
                    return fields.TRANSACTIONTYPE === "I" && fields.RECORDTYPE === "R" && ["A", "S", "C"].includes(fields.STAGE);
                }
                if (id === "GeneratePMProductionUnit") {
                    return fields.TRANSACTIONTYPE === "I" 
                }
                if (id === "ApplyMandatedFees") {
                    return fields.RECORDTYPE === "R";
                }
                if (id === "TransferToDispatch") {
                    return fields.ProfileFMTransferTiming === FmTransferTiming.Batch && fields.RECORDTYPE === RecordTypes.Receipt;
                }
                return true;
            })
            .map(([id, config]) => {
                const base = { id, name: config.name, disabled: config.isHeader };
                if (config.isHeader) return base;
                if (id === "CommitTransaction") {
                    return { ...base, disabled: false };
                }
                if (id === "CalculateCumulativeDiscount") {
                    return { ...base, disabled: !fields.R_DISCOUNTTABLE || fields.R_DISCOUNTTABLE === "00000000-0000-0000-0000-000000000000" };
                }
                if (id === "GeneratePMProductionUnit") {
                    const canProceed=fields.STATUS !== "Z" && fields.RECORDTYPE==="R" && fields.ROWID!=="00000000-0000-0000-0000-000000000000";
                    return { ...base, disabled:  !canProceed};
                }
                if (id === "ApplyMandatedFees") {
                    return { ...base, disabled: fields.STATUS === TransactionStatus.Committed };
                }
                if (id === SPLIT_ORDER_OPERATIONS.SplitOrder) {
                    // Delphi opSplitOrder.Enabled: receipt-type order that is not charge-and-hold.
                    // TransIsChargeAndHold is true for CHARGEANDHOLDTYPE 'B' (Sale/Buyback) OR 'C'
                    // (Shipment) — exclude both (uOMD0000.pas:8982 / uOMM0000.pas:10178).
                    const chargeAndHold = isChargeAndHold(fields.CHARGEANDHOLDTYPE);
                    const canProceed = fields.RECORDTYPE === RecordTypes.Record && !chargeAndHold;
                    return { ...base, disabled: !canProceed };
                }
                if (id === "SplitDeposit") {
                    // Delphi opSplitDeposit.Enabled: receipt-type invoice, not a quote, not charge-and-hold shipment.
                    const canProceed = fields.RECORDTYPE === "R"
                        && fields.TRANSACTIONTYPE === "I"
                        && fields.STAGE !== "Q"
                        && !isChargeAndHoldShipment(fields.CHARGEANDHOLDTYPE);
                    return { ...base, disabled: !canProceed };
                }
                if (id === "TransferToDispatch") {
                    // Delphi opTransferToDispatch.Enabled: not a charge-and-hold sale (CHARGEANDHOLDTYPE = 'B').
                    return { ...base, disabled: fields.CHARGEANDHOLDTYPE === ChargeAndHoldType.Sale };
                }
                if (STAGE_OPERATION_CODES[id]) {
                    return { ...base, disabled: fields.STAGE === STAGE_OPERATION_CODES[id] };
                }
                return base;
            });
        setDropDownItems(items);
    }, []);

    useEffect(() => {
        if (formFields.ROWID && formFields.ROWID !== "00000000-0000-0000-0000-000000000000") {
            setActionDropDownItems();
        } else {
            setDropDownItems([]);
        }
    }, [formFields.ROWID, formFields.STATUS, formFields.TRANSACTIONTYPE, formFields.RECORDTYPE, formFields.STAGE, setActionDropDownItems]);

    const goBack = () => {
        history.push("/om/transactions/salesorders/salesorder-data-entry");
    };

    const EnableControlsForNewRecord = () => {

        if (formRefs.current["R_PROFILE"]) {
            formRefs.current["R_PROFILE"].instance().option('disabled', false);
        }
    }

    const GetItemDataFromProfile = async (profileId,isFromProfileChange=true) => {
        if (profileId === null)
            return;
        setLoadPanelVisible(true);
        try {
            const response = await axios.get(`${window._env_.REACT_APP_APIS}/om/transaction/GetTransaction?profileRowid=${profileId}`, {
                method: 'GET',
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            });

            if (response.hasOwnProperty("data") && response.data != null && response.data != undefined && response.data != "") {
                var responseData = response.data;
                // profile = response.data.Item2;

                if (responseData) {
                    responseData.ROWID = EMPTY_GUID;
                    responseData.RECORD = null;
                    responseData.CREATIONDATETIME = null;
                    responseData.LASTUPDATEDATETIME = null;
                    responseData.CREATIONUSERID = null;
                    responseData.LASTUPDATEUSERID = null;
                    responseData.COMPANYID = null;
                    responseData.TRANSACTIONNUMBER=null;
                    responseData.MODULE = 'OM';
                    responseData.RECORDTYPE = 'R';
                    const exludedFields = [
                        'P_PAYCURRENCYCODE',
                        'CURRENCYRATE',
                        'TRANSCURRENCYTYPE',
                        'PAYCURRENCYTYPE',
                        'RATETIMING',
                        'FOREIGNTAXAMOUNT',
                        'FOREIGNFREIGHTAMOUNT',
                        'FOREIGNOTHERAMOUNT',
                        'FOREIGNTHIRDPARTYCHARGES',
                        'FOREIGNINVOICEAMOUNT']
                    /* Fill the fields from the profile */
                    const latestFormFields = formFieldsRef.current;
                   
                    for (const key in responseData) {
                        if (latestFormFields[key] != null && latestFormFields[key] != '') {
                            if (
                                responseData.PROFILEDEFAULTFXDATA === 'C' &&
                                exludedFields.includes(key)
                            ) {
                                continue;
                            }
                            if (key == "R_CUSTOMER" && responseData.R_CUSTOMER === null && latestFormFields.R_CUSTOMER !== null) {
                                continue;
                            }
                            if(key == "R_CUSTOMER" && !isFromProfileChange){
                                continue;
                            }
                            if (key== "ROWID") {
                                continue;
                            }
                            if (key == "PROFILEDEFAULTSALESPERSON" && responseData.PROFILEDEFAULTSALESPERSON !== 'C') {
                                continue;
                            }
                        }
                           if(key == "R_SHIPPER" && !isFromProfileChange){
                                continue;
                            }
                        latestFormFields[key]=responseData[key] 
                    }
                    if (['A', 'C', 'E', 'F', 'G'].includes(responseData.PROFILETRANSACTIONNUMBERMETHOD)) {
                        let transNumber = await GenerateTransactionNo();
                        if (transNumber && latestFormFields.TRANSACTIONNUMBER===null)
                            latestFormFields.TRANSACTIONNUMBER = (responseData.PROFILEOMPREFIX ?? "") + transNumber;
                    }
                        setformFields(latestFormFields);
                    }
            }
            else {
                console.error('Failed to get transaction profile data');
            }
        } catch (error) {
            console.error('Error fetching transaction profile data:', error);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };
   const handleFieldChange = useCallback((name, value, e) => {
    if(name == 'HOLDATALTERNATEWH'){
        if(value == YesNo.Yes)
        DisableEnableControls('CREATEORDERATALTERNATEWH',false,formRefs)
        else{
        DisableEnableControls('CREATEORDERATALTERNATEWH',true,formRefs)
                setformFields(prevFields => ({
                ...prevFields,
                CREATEORDERATALTERNATEWH: YesNo.No
            }));
        }

    }
       if (name == 'COMMISSIONTYPE') {
           if (value == 'H')
               DisableEnableControls('R_CEACCOUNT', false, formRefs)
           else{
            DisableEnableControls('R_CEACCOUNT', true, formRefs);
            setformFields(prevFields => ({
                ...prevFields,
                R_CEACCOUNT: null
            }));
           }
               
       }
    if(name == 'DISCOUNTTYPE'){
        DiscountTypeChange(value);
    }
   })
const GenerateTransactionNo = async () => {
    const request = {
        Module: "OM",
        TransactionType: "S",
    };

    try {
        const response = await axios.post(
            `${window._env_.REACT_APP_APIS}/${routes.generateTransaction}`,
            request,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );
        return response.data; 
    } catch (err) {
        console.error("Error in generating transaction number:", err);
        return null;
    }
};

    const handleFieldChangePrimary = useCallback((name, value, e,formRefs) => {
         const latestFormFields = formFieldsRef.current;

        const bTmp =
            latestFormFields.PROFILETRANSACTIONNUMBERMETHOD === null ||
            ['C', 'E', 'U', 'G'].includes(latestFormFields.PROFILETRANSACTIONNUMBERMETHOD);

        if (formRefs.current["TRANSACTIONNUMBER"]) {
            var inst = formRefs.current["TRANSACTIONNUMBER"].instance();
            if (inst && typeof inst.option === 'function') {
                inst.option('disabled', bTmp);
            }
        }

        if (name == "R_PROFILE" && !skipDataLoading) {
            GetItemDataFromProfile(value);
        }

        if (name === "R_CUSTOMER" || name === "R_SHIPPER") {
            axios.get(`${window._env_.REACT_APP_APIS}/om/transaction/GetAddresses?rowid=${value}&idtype=${name === "R_CUSTOMER" ? "01" : "02"}`, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            }).then(async (res) => {
                const responseData = res.data;
                if (name === "R_CUSTOMER") {                 
                    let profile = latestFormFields.R_PROFILE;
                    let selectedItem = null;
                    if (value != null && e.component) {
                        selectedItem = e.component.option('selectedItem');

                        if (!profile) {
                            profile = selectedItem?.rOmdefaulttransprofile;
                            await GetItemDataFromProfile(profile,false);
                        }
                        
                    }
                    mergeCustomerAddresses(responseData);
                    setformFields(prevFields => ({
                        ...prevFields,
                        CUSTOMERIDENTITYID: responseData.CUSTOMERIDENTITYID,
                        CUSTOMERNAME: responseData.CUSTOMERNAME,
                        CUSTOMERADDRESS1: responseData.CUSTOMERADDRESS1,
                        CUSTOMERADDRESS2: responseData.CUSTOMERADDRESS2,
                        CUSTOMERCITY: responseData.CUSTOMERCITY,
                        CUSTOMERZIP: responseData.CUSTOMERZIP,
                        CUSTOMERSTATE: responseData.CUSTOMERSTATE,
                        CUSTOMERTELEPHONE1: responseData.CUSTOMERTELEPHONE1,
                        CUSTOMERFAX1: responseData.CUSTOMERFAX1,
                        CUSTOMEREMAILADDRESS1: responseData.CUSTOMEREMAILADDRESS1,
                        CUSTOMERCOUNTRY: responseData.COUNTRY,
                        CUSTOMERADDRESS: responseData.CUSTOMERADDRESS,
                        R_SHIPPER: null,
                        R_PROFILE: profile,
                        SENDFAX: selectedItem?.omsendfax ? selectedItem?.omsendfax : formFields.SENDFAX,
                        SENDEMAIL: selectedItem?.omsendemail ? selectedItem?.omsendemail : formFields.SENDEMAIL,
                        PRINTORDERACKNOWLEDGEMENT: selectedItem?.omprintorderacknowledgement ? selectedItem?.omprintorderacknowledgement : formFields.PRINTORDERACKNOWLEDGEMENT,
                        PRINTPICKINGSLIP: selectedItem?.omprintpickslip ? selectedItem?.omprintpickslip : formFields.PRINTPICKINGSLIP,
                        PRINTDELIVERYNOTIFICATION: selectedItem?.omprintdeliverynotification ? selectedItem?.omprintdeliverynotification : formFields.PRINTDELIVERYNOTIFICATION,
                        PRINTPACKINGSLIP: selectedItem?.omprintpackingslip ? selectedItem?.omprintpackingslip : formFields.PRINTPACKINGSLIP,
                        PRINTBOL: selectedItem?.omprintbol ? selectedItem?.omprintbol : formFields.PRINTBOL,
                        PRINTINVOICE: selectedItem?.omprintinvoice ? selectedItem?.omprintinvoice : formFields.PRINTINVOICE
                    }));
                }
                else if (name === "R_SHIPPER" && e.component) {
                    const selectedItem = e.component.option('selectedItem');
                    let direction = selectedItem.directions;
                    let comment = latestFormFields.TRUCKCOMMENT;
                    if (direction === ' ' && latestFormFields.TRUCKCOMMENT !== null && latestFormFields.TRUCKCOMMENT !== ' ') {
                        confirm(`Consignee's Directions are empty but the current transaction''s directions are not. Do you want to override?`).then((dialogResult) => {
                            if (dialogResult)
                                comment = direction;
                        })
                    }
                    else {
                        comment = direction;
                    }
                    mergeConsigneeAddresses(responseData);
                    setformFields(prevFields => ({
                        ...prevFields,
                        CONSIGNEEIDENTITYID: responseData.CONSIGNEEIDENTITYID,
                        CONSIGNEENAME: responseData.CONSIGNEENAME,
                        CONSIGNEEADDRESS1: responseData.CONSIGNEEADDRESS1,
                        CONSIGNEEADDRESS2: responseData.CONSIGNEEADDRESS2,
                        CONSIGNEECITY: responseData.CONSIGNEECITY,
                        CONSIGNEEZIP: responseData.CONSIGNEEZIP,
                        CONSIGNEESTATE: responseData.CONSIGNEESTATE,
                        CONSIGNEETELEPHONE1: responseData.CONSIGNEETELEPHONE1,
                        CONSIGNEEFAX1: responseData.CONSIGNEEFAX1,
                        CONSIGNEEEMAILADDRESS1: responseData.CONSIGNEEEMAILADDRESS1,
                        CONSIGNEECOUNTRY: responseData.CONSIGNEECOUNTRY,
                        CONSIGNEEADDRESS: responseData.CONSIGNEEADDRESS,
                        TRUCKCOMMENT:comment
                    }));
                }
            });

        }
    });
    const handleSelectionChange = useCallback((name, e) => {
    });

    const handleCommitTransaction = useCallback(async () => {
        const rowId = formFieldsRef.current?.ROWID;
        if (!rowId || rowId === "00000000-0000-0000-0000-000000000000") return;
        let conf = await confirm(MESSAGES.CONFIRM_COMMIT_TRANSACTION, MESSAGES.CONFIRM);
        if (!conf) return;
        if (formFieldsRef.current?.STATUS !== TransactionStatus.ReadyToCommitLater) {
            alert(MESSAGES.STATUS_MUST_BE_READY_TO_COMMIT_LATER, MESSAGES.INFORMATION);
            return;
        }
        setLoadPanelVisible(true);
        try {
            const response = await axios.post(
                `${window._env_.REACT_APP_APIS}/om/SalesOrderHeaderOperations/CommitTransaction`,
                rowId,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            if (response.data.success) {
                notify({ message: response.data.message, width: 300 }, "success", 3000);
                var rowid = props.id;
                if (rowid != null && rowid != undefined && rowid != '') {
                    GetHeaderInfoById(rowid);
                    GetTotals(rowid, formFields.SHIPPINGDATE);
                }
            } else {
                custom({
                    title: MESSAGES.ERROR,
                    messageHtml:MESSAGES.FAILED_TO_COMMIT_TRANSACTION + "<br><br>" + response.data.message + "<br><br>" + MESSAGES.CONTACT_TO_ADMINISTRATOR,
                    buttons: [{ text: "OK", onClick: () => {} }]
                  }).show();
                }
        } catch (error) {
            custom({
                title: MESSAGES.ERROR,
                messageHtml:MESSAGES.FAILED_TO_COMMIT_TRANSACTION + "<br><br>" + error.response?.data?.message + "<br><br>" + MESSAGES.CONTACT_TO_ADMINISTRATOR,
                buttons: [{ text: "OK", onClick: () => {} }]
              }).show();
        } finally {
            setTimeout(hideLoadPanel, 500);
            setLoadPanelVisible(false);
        }
    }, [accessToken]);

    const handleApplyCustomFees = useCallback(async () => {
        const rowId = formFieldsRef.current?.ROWID;
        if (!rowId || rowId === "00000000-0000-0000-0000-000000000000") return;
        let conf = await confirm(MESSAGES.CONFIRM_APPLY_CUSTOM_FEES, MESSAGES.CONFIRM);
        if (!conf) return;
        setLoadPanelVisible(true);
        try {
            const response = await axios.post(
                `${window._env_.REACT_APP_APIS}/om/SalesOrderHeaderOperations/ApplyCustomFees`,
                rowId,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            if (response.data.success) {
               alert(response.data.message,MESSAGES.SUCCESS);
            } else {
               alert(response.data.message,MESSAGES.ERROR);
            }
        } catch (error) {
            alert(error.response?.data?.message || error.message || MESSAGES.FAILED_TO_APPLY_CUSTOM_FEES, MESSAGES.ERROR);
        } finally {
            setTimeout(hideLoadPanel, 500);
            setLoadPanelVisible(false);
        }
    }, [accessToken]);

    const handleApplyMandatedFees = useCallback(async () => {
        const rowId = formFieldsRef.current?.ROWID;
        if (!rowId || rowId === "00000000-0000-0000-0000-000000000000") return;
        const conf = await confirm(MESSAGES.CONFIRM_APPLY_MANDATED_FEES, MESSAGES.CONFIRM);
        if (!conf) return;
        setLoadPanelVisible(true);
        try {
            const response = await axios.post(
                `${window._env_.REACT_APP_APIS}/om/SalesOrderHeaderOperations/ApplyMandatedFees`,
                rowId,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            if (response.data.success) {
                alert(response.data.message, MESSAGES.SUCCESS);
                const shipDate = formFieldsRef.current?.SHIPPINGDATE;
                GetTotals(rowId, shipDate);
                setDetailGridRefreshNonce((n) => n + 1);
                const rid = props.id;
                if (rid != null && rid !== undefined && rid !== "") {
                    GetHeaderInfoById(rid);
                }
            } else {
                alert(response.data.message, MESSAGES.ERROR);
            }
        } catch (error) {
            const msg = error.response?.data?.message || error.message || "Failed to apply mandated fees.";
            alert(msg, MESSAGES.ERROR);
        } finally {
            setTimeout(hideLoadPanel, 500);
            setLoadPanelVisible(false);
        }
    }, [accessToken, hideLoadPanel, props.id]);

    const handleCardConnectPay = useCallback(async (headerRowId, profileToUse, newProfile) => {
        if (!headerRowId || headerRowId === "00000000-0000-0000-0000-000000000000") return;
        setLoadPanelVisible(true);
        try {
            const response = await axios.post(
                `${window._env_.REACT_APP_APIS}/om/SalesOrderHeaderOperations/CardConnectPay`,
                { headerRowId, profileToUse: profileToUse || "", newProfile: newProfile || "" },
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            const data = response.data;
            if (!data.success && data.message) {
                alert(data.message, MESSAGES.ERROR);
            }
        } catch (error) {
            const msg = error.response?.data?.message || error.message;
            if (msg) alert(msg, MESSAGES.ERROR);
        } finally {
            setTimeout(hideLoadPanel, 500);
            setLoadPanelVisible(false);
        }
    }, [accessToken]);

    const handleCardConnectVoidRefund = useCallback(async () => {
        const fields = formFieldsRef.current || {};
        const rowId = fields.ROWID;
        if (!rowId || rowId === "00000000-0000-0000-0000-000000000000") {
            alert("Please SAVE HEADER Record Before Proceeding.", MESSAGES.ERROR);
            return;
        }
        setLoadPanelVisible(true);
        try {
            const verify = await verifyCardConnectVoidRefund(rowId, accessToken);
            if (!verify.success) {
                if (verify.message) {
                    alert(verify.message, MESSAGES.ERROR);
                }
                return;
            }
        } finally {
            setTimeout(hideLoadPanel, 300);
            setLoadPanelVisible(false);
        }
        const agreed = await confirm(MESSAGES.CONFIRM_CARD_CONNECT_VOID_REFUND, MESSAGES.CONFIRM);
        if (!agreed) {
            return;
        }
        setLoadPanelVisible(true);
        try {
            const result = await runCardConnectVoidRefund(rowId, accessToken);
            if (!result.success) {
                if (result.message) {
                    alert(result.message, MESSAGES.ERROR);
                }
                return;
            }
            GetHeaderInfoById(rowId);
        } finally {
            setTimeout(hideLoadPanel, 500);
            setLoadPanelVisible(false);
        }
    }, [accessToken, hideLoadPanel]);

    /* Settles the pending OMD0015 answer: the values on OK, a cancellation on Cancel. The dialog calls
       onApply before onClose, so the onClose that follows an OK finds the resolver already taken and is
       a no-op. */
    const settleAutoSelectLots = useCallback((values) => {
        const settle = autoSelectLotsResolverRef.current;
        autoSelectLotsResolverRef.current = null;
        setShowAutoSelectLots({ visible: false, showLotSelection: false, pickMethod: null, pickSequence: null });
        if (settle) settle(values);
    }, []);

    /**
     * Raises OMD0015 before the stage change is written and waits for the answer, the way Delphi's
     * ShowModal did inside qryOMTransactionHeaderBeforePost. Whether the dialog applies at all is the
     * server's call (GetAutoSelectLotsPrompt evaluates the whole legacy gate against the stored record),
     * so the page only says which stage it is about to write.
     *
     * Resolves to `{ cancelled, allocate, values }` — `cancelled` means abandon the stage change
     * (Delphi called Abort), `allocate` means run the lot allocation once the stage change has saved,
     * and `values` are the dialog's answers.
     */
    const askAutoSelectLots = useCallback(async (headerRowId, stageFrom, stageTo) => {
        if (!headerRowId || headerRowId === EMPTY_GUID) return AUTO_SELECT_LOTS_NOT_ASKED;
        let prompt;
        try {
            const res = await axios.get(
                `${window._env_.REACT_APP_APIS}/${routes.OM.GetAutoSelectLotsPrompt}`,
                {
                    params: { headerRowId, stageFrom: stageFrom ?? "", stageTo: stageTo ?? "" },
                    headers: { access_token: accessToken, Authorization: `Bearer ${accessToken}` },
                }
            );
            prompt = res.data;
        } catch (err) {
            /* The prompt is an extra question, not the operation: failing to ask must not block the
               stage change the user asked for. */
            console.error("Failed to evaluate the automatic lot selection prompt:", err);
            return AUTO_SELECT_LOTS_NOT_ASKED;
        }
        if (!prompt?.showDialog) return AUTO_SELECT_LOTS_NOT_ASKED;

        return new Promise((resolve) => {
            /* Ship Quantity Basis always travels with the stage change; the Lot Selection criteria only
               matter when that group box was shown, which is also the only case that allocates - so
               `allocate` comes from the same prompt that opened the dialog, not from state read later. */
            autoSelectLotsResolverRef.current = (values) =>
                resolve(values
                    ? { cancelled: false, allocate: !!prompt.showLotSelection, values }
                    : AUTO_SELECT_LOTS_CANCELLED);
            setShowAutoSelectLots({
                visible: true,
                showLotSelection: !!prompt.showLotSelection,
                pickMethod: prompt.pickMethod,
                pickSequence: prompt.pickSequence,
            });
        });
    }, [accessToken]);

    /* Runs once the stage change has been saved, with the criteria OMD0015 collected beforehand. Legacy
       allocated inside BeforePost; here the header is written first so the stored stage the lot-selection
       procedure reads is already the new one — the value Delphi passed from its own pending record. */
    const runAutoSelectLots = useCallback(async (values) => {
        const headerRowId = formFieldsRef.current?.ROWID;
        if (!headerRowId || headerRowId === EMPTY_GUID) return;
        setLoadPanelVisible(true);
        try {
            const res = await axios.post(
                `${window._env_.REACT_APP_APIS}/${routes.OM.AutoSelectLots}`,
                {
                    RTransactionheader: headerRowId,
                    Rowid: null,
                    LotPickMethod: values?.LotPickMethod ?? null,
                    LotPickSequence: values?.LotPickSequence ?? null,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            const payload = res.data || {};
            if (payload.success) {
                notify({ message: payload.message, width: 300 }, "success", 3000);
                const shortfalls = payload.partiallyShippedItems ?? [];
                if (shortfalls.length > 0) {
                    alert(
                        `${MESSAGES.AUTO_SELECT_LOTS_PARTIAL_SHIPMENT}<br/>${shortfalls
                            .map((line) => sanitizeHtml(line))
                            .join("<br/>")}`,
                        MESSAGES.WARNING
                    );
                }
            } else {
                alert(payload.message || MESSAGES.ERROR, MESSAGES.ERROR);
            }
        } catch (err) {
            const msg = err.response?.data?.message || err.message;
            alert(typeof msg === "string" ? msg : JSON.stringify(msg), MESSAGES.ERROR);
        } finally {
            // The allocation rewrites detail lines, so the grid and the totals derived from it reload.
            setDetailGridRefreshNonce((n) => n + 1);
            const fields = formFieldsRef.current;
            if (fields?.ROWID) GetTotals(fields.ROWID, fields.SHIPPINGDATE);
            setLoadPanelVisible(false);
        }
    }, [accessToken]);

    // The availability gate (legacy OMD0016) is enforced by the server, so the stage change is simply
    // attempted; a refusal comes back as Success = false plus the check payload the popup renders.
    // acknowledged mirrors the user clicking Continue in that popup.
    const postStageChange = useCallback(
        async (headerRowId, stageFrom, stageTo, reversePayments, shipQuantityBasis, acknowledged) => {
            const response = await axios.post(
                `${window._env_.REACT_APP_APIS}/${routes.OM.StageChange}`,
                {
                    headerRowId: headerRowId,
                    stageFrom: stageFrom,
                    stageTo: stageTo,
                    reversePayments: reversePayments,
                    /* OMD0015's Ship Quantity Basis answer: it becomes SPOM_STAGECHANGE's
                       @inUpdateShipQuantityMethod (uOMM0000.pas:3346-3349), which decides whether ordered
                       quantities are copied onto shipped, and it also decides whether the availability
                       gate runs at all (uOMM0000.pas:4142). */
                    shipQuantityBasis: shipQuantityBasis,
                    availabilityCheckAcknowledged: acknowledged,
                },
                {
                    headers: {
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            return response.data;
        },
        [accessToken]
    );

    /* Delphi qryOMTransactionHeaderBeforePost (uOMM0000.pas:4017-4040): an order due to create an FM
       dispatch object cannot reach a live stage until the three fields FM needs are filled in. Delphi
       tests the pending STAGE — on a stage change, the stage being moved to — and reports only the
       first blank field. Returns the message to refuse with, or null when the order passes. */
    const getFmTransferError = (fields, stageTo) => {
        if (fields.FMTRANSFERFLAG !== FmTransferFlag.Dispatch
            && fields.FMTRANSFERFLAG !== FmTransferFlag.BillingAndDispatch) return null;
        if (!FM_TRANSFER_REQUIRED_STAGES.includes(stageTo)) return null;

        if (!isValidGuid(fields.R_FMDPPROFILE)) return MESSAGES.FM_DISPATCH_PROFILE_REQUIRED;
        if (!isValidGuid(fields.R_FMSHIPPER)) return MESSAGES.FM_SHIPPER_REQUIRED;
        if (!isValidGuid(fields.R_SHIPPER)) return MESSAGES.FM_SHIP_TO_REQUIRED;
        return null;
    };

    const handleStageChange = async (stageTo) => {
        const fields = formFieldsRef.current || {};
        if (!fields.ROWID || fields.ROWID === "00000000-0000-0000-0000-000000000000") {
            alert(MESSAGES.PLEASE_SELECT_TRANSACTION, MESSAGES.ERROR);
            return;
        }
        /* Delphi refused the post here, before it raised OMD0015 (uOMM0000.pas:4017 vs :4125). The API
           enforces the same rule, so this is only about keeping that order: the user is told a field is
           blank instead of first being asked about the shipment. */
        const fmTransferError = getFmTransferError(fields, stageTo);
        if (fmTransferError) {
            alert(fmTransferError, MESSAGES.ERROR);
            return;
        }
        let reversePayments = false;
        if (stageTo === "L") {
            // Wrapped so the dialog wraps at a readable width instead of stretching to the
            // full window width (the message is long).
            const result = await confirm(
                `<div style="max-width: 620px; text-align: left;">${MESSAGES.CANCEL_ORDER_REVERSE_APPLIED_PAYMENTS}</div>`,
                MESSAGES.CONFIRM
            );
            if (!result) return;
            reversePayments = true;
        } else {
            const result = await confirm(
                MESSAGES.STAGE_CHANGED_CONFIRM,
                MESSAGES.CONFIRM
            );
            if (!result) return;
        }
        /* Delphi raised OMD0015 from BeforePost, i.e. before the stage was written, and a Cancel there
           aborted the whole change. Same placement here. */
        const autoSelectLots = await askAutoSelectLots(fields.ROWID, fields.STAGE, stageTo);
        if (autoSelectLots.cancelled) return;

        setLoadPanelVisible(true);
        try {
            const shipQuantityBasis = autoSelectLots.values?.ShipQuantityBasis ?? null;
            const result = await postStageChange(
                fields.ROWID,
                fields.STAGE,
                stageTo,
                reversePayments,
                shipQuantityBasis,
                false
            );
            if (result?.Success) {
                notify(result.Message, "success", 3000);
                GetHeaderInfoById(fields.ROWID);
                if (autoSelectLots.allocate) {
                    await runAutoSelectLots(autoSelectLots.values);
                }
                return;
            }
            // Delphi DisplayErrors: show the review dialog. Continue is hidden for the profile flags
            // that do not allow the user to proceed, which the popup takes from AllowContinue.
            if (result?.AvailabilityCheck?.HasUnavailableQuantities) {
                setShowUnavailableQuantities({
                    visible: true,
                    headerRowId: fields.ROWID,
                    stageFrom: fields.STAGE,
                    stageTo: stageTo,
                    reversePayments: reversePayments,
                    /* Held across the popup so the retry, the Show All reload and the Continue re-check
                       all resolve the same profile flags the refused attempt did. */
                    shipQuantityBasis: shipQuantityBasis,
                    autoSelectLots: autoSelectLots,
                    check: result.AvailabilityCheck,
                });
                return;
            }
            alert(result?.Message || MESSAGES.STAGE_CHANGE_FAILED, MESSAGES.ERROR);
        } catch (error) {
            alert(error?.response?.data || MESSAGES.STAGE_CHANGE_FAILED, MESSAGES.ERROR);
        } finally {
            setLoadPanelVisible(false);
        }
    };

    // Continue in the Items With Unavailable Quantities popup: the popup has already re-run the
    // availability re-check, so the stage change is retried with the acknowledgement set.
    const handleUnavailableQuantitiesContinue = useCallback(async () => {
        const pending = showUnavailableQuantities;
        if (!pending?.headerRowId) return;
        setLoadPanelVisible(true);
        try {
            const result = await postStageChange(
                pending.headerRowId,
                pending.stageFrom,
                pending.stageTo,
                pending.reversePayments,
                pending.shipQuantityBasis,
                true
            );
            if (result?.Success) {
                notify(result.Message, "success", 3000);
                GetHeaderInfoById(pending.headerRowId);
                if (pending.autoSelectLots?.allocate) {
                    await runAutoSelectLots(pending.autoSelectLots.values);
                }
                return;
            }
            alert(result?.Message || MESSAGES.STAGE_CHANGE_FAILED, MESSAGES.ERROR);
        } catch (error) {
            alert(error?.response?.data || MESSAGES.STAGE_CHANGE_FAILED, MESSAGES.ERROR);
        } finally {
            setLoadPanelVisible(false);
        }
    }, [postStageChange, showUnavailableQuantities, runAutoSelectLots]);

    const onItemClick = async (e) => {
        if (e.itemData?.disabled) return;
        const id = e.itemData?.id;
        if (id === "CommitTransaction") {
            await handleCommitTransaction();
            return;
        }
        if (id === "ApplyCustomFees") {
            await handleApplyCustomFees();
            return;
        }
        if (id === "ApplyMandatedFees") {
            await handleApplyMandatedFees();
            return;
        }
        if (id === "DisplayProductionStatus") {
            setShowProductionStatusPopup({ visible: true, headerRowId: formFields.ROWID, title: "Production Status" });
            return;
        }
        if (id === "CalculateCumulativeDiscount") {
            setShowCumulativeDiscountPopup({
                visible: true,
                headerRowId: formFields.ROWID,
                rCustomer: formFields.R_CUSTOMER || null,
                rDiscountTable: formFields.R_DISCOUNTTABLE || null,
                shippingDate: formFields.SHIPPINGDATE || null,
                companyId: formFields.COMPANYID || props.oidc?.user?.profile?.COMPANYID || null,
                discountCode: null,
            });
            return;
        }
        if (id === "CreateRequisition") {
            await onCreatePORequisition();
            return;
        }
        if (id === "CardConnectPay") {
            const fields = formFieldsRef.current || {};
            const rowId = fields.ROWID;
            if (!rowId || rowId === "00000000-0000-0000-0000-000000000000") {
                alert("Please SAVE HEADER Record Before Proceeding.", MESSAGES.ERROR);
                return;
            }
            setLoadPanelVisible(true);
            try {
                const pre = await prepareCardConnectPayOpen(rowId, accessToken);
                if (!pre.success) {
                    if (pre.message) {
                        alert(pre.message, MESSAGES.ERROR);
                    }
                    return;
                }
                setShowCardConnectPayPopup({
                    visible: true,
                    headerRowId: rowId,
                    transactionNumber: (fields.TRANSACTIONNUMBER || "").trim(),
                    customer: fields.CUSTOMERIDENTITYID ?? "",
                    amount: pre.amount,
                    paymentProfile: (fields.PaymentProfile || "").trim(),
                });
            } finally {
                setTimeout(hideLoadPanel, 300);
                setLoadPanelVisible(false);
            }
            return;
        }
        if (id === "CardConnectVoidRefund") {
            await handleCardConnectVoidRefund();
            return;
        }
        if (id === "RecalculatePrices") {
            let conf = await confirm(MESSAGES.CONFIRM_UPDATE_PRICES, MESSAGES.CONFIRM);
            if (!conf) return;
            if(formFields.STATUS !== Statuses.ReadyToCommitLater && formFields.STATUS !==Statuses.Open) {
                alert(MESSAGES.STATUS_MUST_BE_READY_TO_COMMIT_LATER_OR_OPEN, MESSAGES.ERROR);
                return;
            }
            await updatePrices();
            return;
        }
        if (STAGE_OPERATION_CODES[id]) {
            await handleStageChange(STAGE_OPERATION_CODES[id]);
            return;
        }
        if (id === "GeneratePMProductionUnit") {
            await handleGeneratePMProductionUnit(formFieldsRef.current?.ROWID);
            return;
        }
        if (id === SPLIT_ORDER_OPERATIONS.SplitOrder || id === SPLIT_ORDER_OPERATIONS.ByTransaction || id === SPLIT_ORDER_OPERATIONS.ByTransactionAdvanced) {
            setShowSplitOrderPopup({
                visible: true,
                splitMode: id === SPLIT_ORDER_OPERATIONS.SplitOrder ? SplitOrderMode.CurrentOrder : SplitOrderMode.ByTransaction,
                advanced: id === SPLIT_ORDER_OPERATIONS.ByTransactionAdvanced,
                headerRowId: formFields.ROWID,
                sourceRProfile: formFields.R_PROFILE,
                sourceWarehouse: formFields.R_FMSHIPPER ?? formFields.R_PRIMARYDEFAULTWH ?? formFields.R_SECONDARYDEFAULTWH,
            });
            return;
        }
        if (id === "SplitDeposit") {
            setShowSplitDepositPopup({ visible: true, headerRowId: formFields.ROWID });
            return;
        }
        if (id === "TransferToDispatch") {
            await handleTransferToDispatch();
            return;
        }
    if(id=="ShowCustomerCredit"){
     setShowCustomerCreditForm(true);
    }
    if(id=="ShowCustomerHistory"){
     setShowCustomerHistory({ visible: true, headerRowId: formFields.ROWID, customerId: formFields.R_CUSTOMER });
    }
    };
   const updatePrices = async () => {
        try {
            setLoadPanelVisible(true);
          let updatePriceParams= {
                priceLevel: formFields.PRICELEVEL,
                applyAdjustmentFactor: 'N',
                ['filterWhereInfoList']: [{
                    FieldName: 'ROWID',
                    FieldType: '0',
                    Operation:"3",
                    Origin:"OMTransactionHeader.ROWID",
                    From: formFields.ROWID
                }]
              };
          const res = await axios.post(
            `${window._env_.REACT_APP_APIS}/${routes.OM.CallUpdatePrice}`,
            JSON.stringify(updatePriceParams),
            {
              headers: {
                "Content-Type": "application/json",
                access_token: accessToken,
                Authorization: `Bearer ${accessToken}`,
              },
            }
          );
          if (res.data) {
            alert(MESSAGES.UPDATE_PRICES_SUCCESS, MESSAGES.SUCCESS);
            GetHeaderInfoById(formFields.ROWID);
            setDetailGridRefreshNonce((n) => n + 1);
          } else {
            alert(res.data.message, MESSAGES.ERROR);
          }
        } catch (error) {
            setLoadPanelVisible(false);
           alert(error.response?.data?.message || error.message || MESSAGES.ERROR, MESSAGES.ERROR);
        } finally {
          setLoadPanelVisible(false);
        }
      };

    const okToTransferToFM = (fields) => {
        const allowedStages = fields.ProfileFMTransferStage === OrderStages.Assigned
            ? [OrderStages.Assigned, OrderStages.PickedStaged, OrderStages.ShippedCompleted]
            : [OrderStages.Pending, OrderStages.Assigned, OrderStages.PickedStaged, OrderStages.ShippedCompleted];
        return isValidGuid(fields.R_SHIPPER)
            && (fields.FMTRANSFERFLAG === FmTransferFlag.Dispatch || fields.FMTRANSFERFLAG === FmTransferFlag.BillingAndDispatch)
            && fields.RECORDTYPE === RecordTypes.Record
            && fields.TRANSACTIONTYPE === TransactionTypes.Invoice
            && allowedStages.includes(fields.STAGE)
            && isValidGuid(fields.R_FMSHIPPER);
    };

    const handleTransferToDispatch = useCallback(async () => {
        const fields = formFieldsRef.current || {};
        const rowId = fields.ROWID;
        if (!rowId || rowId === EMPTY_GUID) return;

        if (!okToTransferToFM(fields)) {
            alert(MESSAGES.TRANSFER_TO_DISPATCH_SETUP_ERROR, MESSAGES.ERROR);
            return;
        }

        const conf = await confirm(MESSAGES.CONFIRM_TRANSFER_TO_DISPATCH, MESSAGES.CONFIRM);
        if (!conf) return;

        setLoadPanelVisible(true);
        try {
            // Single-order transfer: scope via the SP's dedicated @InHeaderRowID parameter
            // (Delphi opTransferToDispatch), not a client-built ROWID filter.
            const requestBody = {
                Comment: "",
                HeaderRowId: rowId,
            };
            const res = await axios.post(
                `${window._env_.REACT_APP_APIS}/${routes.OM.CallOMBatchTransferToDispatch}`,
                JSON.stringify(requestBody),
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            const affectedRecords = parseInt(res.data, 10);
            if (affectedRecords > 0) {
                notify({ message: MESSAGES.TRANSFER_TO_DISPATCH_SUCCESS, width: 300 }, "success", 3000);
            } else if (affectedRecords === 0) {
                alert(MESSAGES.TRANSFER_TO_DISPATCH_ALREADY_TRANSFERRED, MESSAGES.INFORMATION);
            } else {
                alert(MESSAGES.TRANSFER_TO_DISPATCH_ERROR, MESSAGES.ERROR);
            }
        } catch (error) {
            alert(error.response?.data?.message || error.message || MESSAGES.TRANSFER_TO_DISPATCH_ERROR, MESSAGES.ERROR);
        } finally {
            setTimeout(hideLoadPanel, 500);
            setLoadPanelVisible(false);
        }
    }, [accessToken]);

    const handleGeneratePMProductionUnit = useCallback(async (headerRowId) => {
        if (!headerRowId || headerRowId === "00000000-0000-0000-0000-000000000000") return;
        const agreed = await confirm(
            "Generate PM Production Units from this sales order?",
            MESSAGES.CONFIRM
        );
        if (!agreed) return;

        const escapeHtml = (s) => {
            if (s == null || s === "") return "";
            const d = document.createElement("div");
            d.textContent = String(s);
            return d.innerHTML;
        };

        /** Builds scrollable multiline HTML for PM generate API payload (success or error body). */
        const buildPmResponseMessageHtml = (data) => {
            const parts = [];
            if (data?.message) {
                parts.push(
                    `<p style="margin:0 0 10px 0;font-weight:600;">${escapeHtml(data.message)}</p>`
                );
            }
            if (data?.planNumber) {
                parts.push(
                    `<p style="margin:0 0 8px 0;text-align:left;"><strong>Plan number:</strong> ${escapeHtml(data.planNumber)}</p>`
                );
            }
            if (Array.isArray(data?.productionUnitCodes) && data.productionUnitCodes.length > 0) {
                const items = data.productionUnitCodes
                    .map((c) => `<li style="margin:2px 0;">${escapeHtml(c)}</li>`)
                    .join("");
                parts.push(
                    `<p style="margin:8px 0 4px 0;text-align:left;"><strong>Production units</strong></p><ul style="margin:0 0 10px 18px;padding:0;text-align:left;">${items}</ul>`
                );
            }
            const logs = Array.isArray(data?.logMessages) ? data.logMessages.filter(Boolean) : [];
            if (logs.length > 0) {
                const logLines = logs.map((line) => escapeHtml(line)).join("<br />");
                parts.push(
                    `<div style="margin-top:8px;padding-top:10px;border-top:1px solid #ddd;text-align:left;"><strong style="display:block;margin-bottom:6px;">Log</strong></div>` +
                        `<div style="max-height:min(360px,50vh);overflow-y:auto;text-align:left;font-size:13px;line-height:1.5;padding:8px 10px;background:#f8f9fa;border-radius:4px;border:1px solid #e9ecef;">${logLines}</div>`
                );
            }
            if (parts.length === 0) {
                parts.push(`<p style="margin:0;text-align:left;">${escapeHtml("No details returned.")}</p>`);
            }
            return `<div style="min-width:280px;max-width:560px;">${parts.join("")}</div>`;
        };

        setLoadPanelVisible(true);
        try {
            const response = await axios.post(
                `${window._env_.REACT_APP_APIS}/om/SalesOrderHeaderOperations/GeneratePmProductionUnitsFromSalesOrder`,
                { omTransactionHeaderRowId: headerRowId },
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            const data = response.data;
            custom({
                title: data.success ? "PM Production Unit" : MESSAGES.INFORMATION,
                messageHtml: buildPmResponseMessageHtml(data),
                buttons: [{ text: "OK", onClick: () => {} }],
            }).show();
        } catch (error) {
            const errData = error.response?.data;
            const payload = errData && typeof errData === "object" ? errData : {};
            const fallbackMsg =
                error.message ||
                MESSAGES.ERROR ||
                "Request failed.";
            const dataForDialog = {
                message: payload.message || fallbackMsg,
                planNumber: payload.planNumber,
                productionUnitCodes: payload.productionUnitCodes,
                logMessages: Array.isArray(payload.logMessages) ? payload.logMessages : [],
            };
            if (!dataForDialog.logMessages.length && typeof errData === "string") {
                dataForDialog.logMessages = [errData];
            }
            custom({
                title: MESSAGES.ERROR,
                messageHtml: buildPmResponseMessageHtml(dataForDialog),
                buttons: [{ text: "OK", onClick: () => {} }],
            }).show();
        } finally {
            setTimeout(hideLoadPanel, 500);
            setLoadPanelVisible(false);
        }
    }, [accessToken, hideLoadPanel]);
    const renderItem = (itemData) => {
        const isHeader = OMOperations[itemData.id]?.isHeader === true;
        if (isHeader) {
            return <div style={{ fontWeight: "bold", borderBottom: "1px solid #ccc" }}>{itemData.name}</div>;
        }
        const isDisabled = itemData.disabled === true;
        return (
            <span style={{
                opacity: isDisabled ? 0.5 : 1,
                cursor: isDisabled ? "not-allowed" : "pointer",
                pointerEvents: isDisabled ? "none" : "auto",
            }}>
                {itemData.name}
            </span>
        );
    };
    const onCreatePORequisition = async () => {
        if (!formFields.ROWID || formFields.ROWID ===EMPTY_GUID) {
            alert(MESSAGES.PLEASE_SELECT_TRANSACTION, MESSAGES.ERROR);
            return;
        }
        setLoadPanelVisible(true);
        try {
            const response = await axios.get(
                `${window._env_.REACT_APP_APIS}/po/RequisitionHeader/GetRequisitionDataSet`,
                {
                    params: {
                        headerRowId: formFields.ROWID,
                    },
                    headers: {
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            const data = Array.isArray(response.data) ? response.data : response.data?.data ?? [];

            let defaults = {};
            try {
                const defaultsResponse = await axios.get(
                    `${window._env_.REACT_APP_APIS}/om/SaleOrder/GetRequisitionDefaultsForHeader`,
                    {
                        params: { headerRowId: formFields.ROWID },
                        headers: {
                            access_token: accessToken,
                            Authorization: `Bearer ${accessToken}`,
                        },
                    }
                );
                defaults = defaultsResponse?.data || {};
            } catch (err) {
                console.warn('GetRequisitionDefaultsForHeader failed, using form fields:', err);
            }

            const requisitionFormFields = {
                RequisitionProfile: defaults.R_REQUISITIONDEFAULTPROFILE ?? formFields.R_PROFILE,
                Source: SourceTypes.Requisition,
                Reference: defaults.TRANSACTIONNUMBER ?? formFields.REFERENCE ?? '',
                TransDate: formFields.TRANSACTIONDATE ?? null,
                RequiredDate: formFields.TRANSACTIONDATE ?? null,
                Department: defaults.R_GLDEPARTMENT ?? null,
                Job: defaults.R_CAJOB ?? null,
                Fund: defaults.R_GLFUND ?? null,
                R_FMShipper: defaults.R_FMSHIPPER ?? null,
                IsOpenFromDetails: true,
            };
            setSelectedRequisitionData({visible: true, data: data, formFields: requisitionFormFields});
        } catch (error) {
            console.error('Error loading requisition dataset:', error);
            alert(error.response?.data ?? error.message ?? MESSAGES.ERROR, MESSAGES.ERROR);
        } finally {
            setTimeout(hideLoadPanel, 500);
        }
    };
    const GetTotals = async (omHeaderRowID, shipDate) => {
        try {
            const apiUrl = `${window._env_.REACT_APP_APIS}/om/SaleOrder/GetTotals`;
            const response = await axios.get(apiUrl, {
                params: {
                    omHeaderRowID: omHeaderRowID,
                    shipDate: shipDate
                },
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            });
            const responseData = response.data;
            if (responseData.success) {
                setSelectedTotals(responseData.result);
            } else {
                console.error('Failed to get totals:');
            }
        } catch (error) {
            console.error('Error fetching totals:', error);
        }
    };
    return (
            <>
            <div className="row dataEntryMainPage">
                <div className="col-md-12 main-page">
                    <div id="accordion">
                        <LoadPanel
                            shadingColor="rgba(0,0,0,0.4)"
                            position={position}
                            onHiding={hideLoadPanel}
                            visible={loadPanelVisible}
                            showIndicator={true}
                            shading={true}
                            showPane={true}
                            hideOnOutsideClick={false}
                        />
                        <form onSubmit={(e) => handleFormSubmit(e)}>
                            <Toolbar className="header">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2,
                                                marginLeft: '12px',
                                                marginTop: '0px',
                                                marginBottom: 0
                                            }}
                                        >
                                            Sales Order Data Entry
                                        </h6>
                                    </div>
                                </Item>
                                {selectedTabIndex !== 0 && (
                                    <Item location="before">
                                        <EntityInfoBar
                                            fields={[
                                                { label: 'Trans #', value: formFields.TRANSACTIONNUMBER },
                                                { label: 'Customer', value: formFields.CUSTOMERNAME },
                                                { label: 'Ship Date', value: formFields.SHIPPINGDATE, format: 'date' },
                                                // The stage map moved to the caller with the rest of the
                                                // labels; it was always OM-specific.
                                                { label: 'Stage', value: OM_STAGE_TEXT[formFields.STAGE] || formFields.STAGE },
                                            ]}
                                        />
                                    </Item>
                                )}
                                <Item location="after">
                                    <Button
                                        text="Save"
                                        useSubmitBehavior={true}
                                        disabled={isFormSubmitted}
                                        type="default"
                                        className="accordianButton"
                                    />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={addNewRecordClick} text="New" type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={DeleteClick} text="Delete" disabled={formFields.ROWID === "00000000-0000-0000-0000-000000000000"} type="default" />
                                </Item>
                                <Item location="after">
                                    <PrintReportMenu
                                        className="accordianButton"
                                        selectedRecord={{ recordNumber: formFields.RECORD }}
                                        disabled={formFields.ROWID === "00000000-0000-0000-0000-000000000000"}
                                    />
                                </Item>
                                <Item location="after">
                                <DropDownButton
                                    text="Operations"
                                    icon="preferences"
                                    dropDownOptions={buttonDropDownOptions}
                                    items={dropDownItems}
                                    onItemClick={onItemClick}
                                    displayExpr="name"
                                    keyExpr="id"
                                    disabled={formFields.ROWID === "00000000-0000-0000-0000-000000000000"} 
                                    itemRender={renderItem}
                                    />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={goBack} text="Back" disabled={!backButtonEnabled} />
                                </Item>
                            </Toolbar>
                            <TabPanel deferRendering={props.id ? true : false} showNavButtons={true} height={"auto"} selectedIndex={selectedTabIndex} onSelectionChanged={(e) => setSelectedTabIndex(e.component.option('selectedIndex'))}>
                                <TabItem title="Primary">
                                    <PrimaryTab formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChangePrimary} handleSelectionChange={handleSelectionChange} primaryFormLookupsLoad={primaryFormLookupsLoad}/>
                                    <div style={{ paddingTop: '20px', paddingBottom: '20px' }}>
                                        <div style={{ display: 'flex', border: '0px solid black' }}>
                                            <div style={{ flex: 1, padding: '2px', width: '10vw',marginLeft: '15px',  border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                                                Non Taxable:
                                            </div>
                                            <div style={{ flex: 1, padding: '2px', width: '10vw', borderTop: '1px solid ' + (window._env_.Color2), borderLeft: '1px solid ' + (window._env_.Color2), borderRight: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                                                {selectedTotals?.nonTaxed?.toFixed(2)}
                                            </div>
                                            <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                                                Taxable/Tax:
                                            </div>
                                            <div style={{ flex: 1, padding: '2px', width: '10vw', borderTop: '1px solid ' + (window._env_.Color2), borderLeft: '1px solid ' + (window._env_.Color2), borderRight: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                                                {selectedTotals?.taxed == 0 ? 0.00 : (selectedTotals?.taxed / selectedTotals?.totalTax===0?1:selectedTotals?.totalTax)?.toFixed(2)}
                                            </div>
                                            <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                                                Item Total:
                                            </div>
                                            <div style={{ flex: 1, padding: '2px', marginRight: '15px', width: '10vw', borderTop: '1px solid ' + (window._env_.Color2), borderLeft: '1px solid ' + (window._env_.Color2), borderRight: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                                                {selectedTotals?.itemTotal?.toFixed(2)}
                                            </div>

                                        </div>
                                        <div style={{ display: 'flex', border: '0px solid black' }}>
                                            <div style={{ flex: 1, padding: '2px', marginLeft: '15px', width: '10vw', border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                                                Total Amount:
                                            </div>
                                            <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                                                {selectedTotals?.totalAmount?.toFixed(2)}
                                            </div>
                                            <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                                                Balance Due:
                                            </div>
                                            <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                                                {selectedTotals?.outARBalanceDue?.toFixed(2)}
                                            </div>
                                            <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                                                Tran Currency:
                                            </div>
                                            <div style={{ flex: 1, padding: '2px', width: '10vw',marginRight: '15px', border: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                                                {selectedTotals?.currency}
                                            </div>

                                        </div>
                                    </div>
                                </TabItem>
                                <TabItem title="Additional" >
                                     <AdditionalTab formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange}  handleSelectionChange={handleSelectionChange}   additionalFormLookupsLoad={additionalFormLoad} formRefs={formRefs} />
                                </TabItem>
                                <TabItem title="Trips" >
                                     <TripsTab formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange}  handleSelectionChange={handleSelectionChange} tripFormLoad={tripFormLoad}/>
                                </TabItem>
                                <TabItem title="Details" disabled={formFields.ROWID===EMPTY_GUID}>
                                <DetailsTab
                                    formFields={formFields}
                                    changeTotals={GetTotals}
                                    detailGridRefreshNonce={detailGridRefreshNonce}
                                    onTransactionDetailDataChanged={() => {
                                        setDetailGridRefreshNonce((n) => n + 1);
                                        const f = formFieldsRef.current;
                                        if (f?.ROWID) GetTotals(f.ROWID, f.SHIPPINGDATE);
                                    }}
                                />
                                </TabItem>
                                <TabItem title="Misc" >
                                    <MiscTab formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange}  handleSelectionChange={handleSelectionChange} onFormLoad={handleMiscFormLoad} formRefs ={formRefs}/>
                                </TabItem>
                                 <TabItem title="User Defined" >
                                     <UserDefinedTab formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange}  handleSelectionChange={handleSelectionChange} onFormLoad={handleMiscFormLoad} formRefs ={formRefs}/>
                                </TabItem>
                                <TabItem title="Commissions" >
                                     <CommissionTab formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange}  handleSelectionChange={handleSelectionChange} onFormLoad={handleCommissionFormLoad} formRefs ={formRefs}/>
                                </TabItem>
                               <TabItem title="Payment" >
                                     <PaymentTab formFields={formFields} refreshNonce={paymentRefreshNonce}/>
                                </TabItem>
                                <TabItem title="Retainers" >
                                     <RetainersTab formFields={formFields} selectedTotals ={selectedTotals}/>
                                     </TabItem>
                                <TabItem title="Totals">
                                    <TotalsTab selectedTotals={selectedTotals} formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange}  handleSelectionChange={handleSelectionChange} onFormLoad={handleTotalsFormLoad} formRefs={formRefs}/>
                                </TabItem>
                                <TabItem title="Freight" >
                                     <FreightTab formFields={formFields}/>
                                </TabItem>
                            </TabPanel>
                            <div className="row">
                                <ValidationSummary className="pl-3 pt-1" id="summary" />
                            </div>
                        </form>
                    </div>

                </div>
            </div>
            <SplitOrderPopup
                showPopup={showSplitOrderPopup}
                setShowPopup={setShowSplitOrderPopup}
                setLoadPanelVisible={setLoadPanelVisible}
                onSuccess={({ newHeaderRowId, openSplitOrder } = {}) => {
                    // Delphi OMD0018 "Open Split Order": load the newly created order in place of
                    // the source order. Otherwise stay on the source order and just refresh it.
                    if (openSplitOrder && newHeaderRowId && newHeaderRowId !== EMPTY_GUID) {
                        openTransactionById(newHeaderRowId);
                        return;
                    }
                    GetTotals(formFields.ROWID, formFields.SHIPPINGDATE);
                    setDetailGridRefreshNonce(n => n + 1);
                }}
            />
            <ItemsWithUnavailableQuantitiesPopup
                showPopup={showUnavailableQuantities}
                setShowPopup={setShowUnavailableQuantities}
                onContinue={handleUnavailableQuantitiesContinue}
            />
            <SplitDepositPopup
                showPopup={showSplitDepositPopup}
                setShowPopup={setShowSplitDepositPopup}
                setLoadPanelVisible={setLoadPanelVisible}
                accessToken={accessToken}
                onSuccess={async () => {
                    // Delphi opSplitDepositClick refreshes the order totals, detail and payment form after the split.
                    // Keep the parent load panel up until the refreshed data has loaded.
                    setLoadPanelVisible(true);
                    try {
                        await GetTotals(formFields.ROWID, formFields.SHIPPINGDATE);
                        setDetailGridRefreshNonce((n) => n + 1);
                        setPaymentRefreshNonce((n) => n + 1);
                    } finally {
                        setLoadPanelVisible(false);
                    }
                }}
            />
            <ProductionStatusPopup showPopup={showProductionStatusPopup} setShowPopup={setShowProductionStatusPopup} setLoadPanelVisible={setLoadPanelVisible} />
            <CreateRequisitionPopup showPopup={selectedRequisitionData} setShowPopup={setSelectedRequisitionData} title="Create PO Requisition"  setLoadIndicatorVisible={setLoadPanelVisible} />
            <CalculateCumulativeDiscountPopup showPopup={showCumulativeDiscountPopup} setShowPopup={setShowCumulativeDiscountPopup} setLoadPanelVisible={setLoadPanelVisible} onApplied={() => { GetTotals(formFields.ROWID, formFields.SHIPPINGDATE); }} />
            <CardConnectPayPopup showPopup={showCardConnectPayPopup} setShowPopup={setShowCardConnectPayPopup} onConfirm={handleCardConnectPay} />
            {showCustomerCreditForm && (
                <Popup
                    visible={showCustomerCreditForm}
                    onHiding={() => setShowCustomerCreditForm(false)}
                    width="90vw" 
                    height="90vh"
                    title="Customer Credit Status"
                    showCloseButton={true}
                >
                    <div ref={customerCreditPopupRef} style={{ height: "100%", position: "relative" }}>
                        <LoadPanel
                            shadingColor="rgba(0,0,0,0.4)"
                            container={customerCreditPopupRef.current ?? undefined}
                            position={customerCreditPopupRef.current ? { my: "center", at: "center", of: customerCreditPopupRef.current } : undefined}
                            visible={customerCreditLoading}
                            showIndicator={true}
                            shading={true}
                            showPane={true}
                            hideOnOutsideClick={false}
                        />
                        <CustomerCredit
                            customerId={formFields.R_CUSTOMER}
                            module="OM"
                            onLoadingChange={setCustomerCreditLoading}
                        />
                    </div>
                </Popup>
            )}
            <CustomerHistoryPopup showPopup={showCustomerHistory} setShowPopup={setShowCustomerHistory} />
            <AutoSelectLotsPopup
                visible={showAutoSelectLots.visible}
                onClose={() => settleAutoSelectLots(null)}
                onApply={(values) => settleAutoSelectLots(values)}
                showLotSelection={showAutoSelectLots.showLotSelection}
                defaultPickMethod={showAutoSelectLots.pickMethod}
                defaultPickSequence={showAutoSelectLots.pickSequence}
            />
            </>

    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(Form);
